/* Kaynak: sections/header-yeni.liquid eski inline <script> blogu (~2400 satir).
   Dinamik degerler header-yeni.liquid'deki bootstrap scriptte window._headerYeni /
   window._headerYeniI18n olarak veriliyor. Sync (defer'siz) yukleniyor:
   yurutme sirasi inline haliyle ayni. '{{'+'amount}}' literalleri money-format
   placeholder'i, Liquid degil - dokunulmadi. */
  (function () {
    // ---- Header offset & scroll shrink ----
    var header = document.querySelector('.header-yeni');
    if (!header) return;

    var offsetFrame = null;
    function getTargetHeaderHeight() {
      var isMobile = window.matchMedia('(max-width: 989px)').matches;
      var isExpanded = header.classList.contains('header-yeni--home') && !header.classList.contains('is-compact');
      if (isExpanded) return isMobile ? 128 : window._headerYeni.headerHeightExpanded;
      return isMobile ? 52 : window._headerYeni.headerHeight;
    }
    function getCompactHeaderHeight() {
      var isMobile = window.matchMedia('(max-width: 989px)').matches;
      return isMobile ? 52 : window._headerYeni.headerHeight;
    }
    function setOffset() {
      if (offsetFrame) cancelAnimationFrame(offsetFrame);
      offsetFrame = requestAnimationFrame(function () {
        offsetFrame = null;
        var compactH = getCompactHeaderHeight() + 'px';
        document.documentElement.style.setProperty('--header-yeni-h', getTargetHeaderHeight() + 'px');
        document.documentElement.style.setProperty('--header-compact-height', compactH);
        document.documentElement.style.setProperty('--header-yeni-compact-height', compactH);
      });
    }
    var initialCompactH = getCompactHeaderHeight() + 'px';
    document.documentElement.style.setProperty('--header-yeni-h', getTargetHeaderHeight() + 'px');
    document.documentElement.style.setProperty('--header-compact-height', initialCompactH);
    document.documentElement.style.setProperty('--header-yeni-compact-height', initialCompactH);
    new MutationObserver(setOffset).observe(header, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', setOffset, { passive: true });

    if (header.classList.contains('header-yeni--home')) {
      // Tek esikte (scrollY > 10) toggle yapmak, scroll 8-12px araliginda
      // salinirken (trackpad/mouse wheel mikro adimlari, iOS elastik bounce)
      // is-compact'in surekli acilip kapanmasina, dolayisiyla logo buyume/
      // kuculme transition'inin her seferinde en bastan tetiklenip "px px"
      // adim adim ilerliyormus gibi gorunmesine sebep oluyordu. Iki farkli
      // esik (hysteresis) ile bu salinim/flicker onleniyor.
      function update() {
        var y = window.scrollY;
        if (y > 40) header.classList.add('is-compact');
        else if (y <= 10) header.classList.remove('is-compact');
      }
      window.addEventListener('scroll', update, { passive: true });
      update();
    }

    // ---- Scrollbar compensation (prevents CLS when drawers/overlays open) ----
    function _lockScrollbar() {
      if (CSS && CSS.supports && CSS.supports('scrollbar-gutter', 'stable')) return;
      var sw = window.innerWidth - document.documentElement.clientWidth;
      if (sw > 0) {
        document.body.style.paddingRight = sw + 'px';
        header.style.paddingRight = sw + 'px';
      }
    }
    function _unlockScrollbar() {
      document.body.style.paddingRight = '';
      header.style.paddingRight = '';
    }

    // ---- Menu Drawer ----
    var drawer     = document.getElementById('header-yeni-menu');
    var hamburger  = document.querySelector('.header-yeni__hamburger');
    var cartBack   = document.querySelector('[data-header-cart-back]');

    // Some external cart-count sync scripts write the item count into the
    // first aria-hidden node they find. On cart updates that can replace this
    // button's SVG path with a text node (for example: <svg>5</svg>).
    // Keep the decorative icon self-healing without interfering with the
    // button's accessible label or click behaviour.
    if (cartBack) {
      var cartBackSvg = cartBack.querySelector('svg');
      var cartBackSvgMarkup = cartBackSvg ? cartBackSvg.innerHTML : '';
      var restoringCartBackSvg = false;
      var restoreCartBackSvg = function () {
        if (restoringCartBackSvg || !cartBackSvgMarkup) return;
        var currentSvg = cartBack.querySelector('svg');
        if (!currentSvg || currentSvg.querySelector('path')) return;
        restoringCartBackSvg = true;
        currentSvg.innerHTML = cartBackSvgMarkup;
        restoringCartBackSvg = false;
      };
      new MutationObserver(restoreCartBackSvg).observe(cartBack, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    if (window.location.pathname.includes('/wishlist') || window.location.pathname.includes('/apps/wishlist') || document.querySelector('.wk-wishlist-page')) {
      if (cartBack) cartBack.style.display = '';
      if (hamburger) hamburger.classList.add('header-yeni__hamburger--cart');
    }

    if (cartBack) {
      cartBack.addEventListener('click', function () {
        var referrerIsSameSite = false;
        if (document.referrer) {
          try {
            referrerIsSameSite = new URL(document.referrer).origin === window.location.origin;
          } catch (error) {
            referrerIsSameSite = false;
          }
        }

        if (referrerIsSameSite && window.history.length > 1) {
          window.history.back();
        } else {
          window.location.href = cartBack.dataset.fallbackUrl || '/';
        }
      });
    }

    // Madde 17: body.drawer-open{overflow:hidden} tek başına iOS Safari'de
    // yeterli değil - adres çubuğu göster/gizle davranışıyla scroll sırasında
    // menü paneli anlık zıplıyor, altta kalan sayfa kısa süreli görünüyordu.
    // PDP'deki (product-yeni.liquid) lockBodyScroll/unlockBodyScroll ile aynı
    // iOS-safe teknik: position:fixed + kaydedilmiş scrollY.
    var _drawerScrollY = 0;
    function _lockBodyScroll() {
      if (document.body.style.position === 'fixed') return;
      _drawerScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + _drawerScrollY + 'px';
      document.body.style.width = '100%';
    }
    function _unlockBodyScroll() {
      if (document.body.style.position !== 'fixed') return;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, _drawerScrollY);
    }

    if (drawer) {
      var dOverlay    = drawer.querySelector('.menu-drawer__overlay');
      var dCloseBtn   = drawer.querySelector('.menu-drawer__close');
      var dMobileClose = drawer.querySelector('.menu-drawer__mobile-close-btn');
      var dMobileMain = drawer.querySelector('.menu-drawer__mobile-main');

      function openDrawer() {
        _lockScrollbar();
        _lockBodyScroll();
        drawer.setAttribute('aria-hidden', 'false');
        drawer.classList.add('is-open');
        document.body.classList.add('drawer-open');
        if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
      }

      function closeDrawer() {
        _unlockScrollbar();
        _unlockBodyScroll();
        drawer.setAttribute('aria-hidden', 'true');
        drawer.classList.remove('is-open');
        document.body.classList.remove('drawer-open');
        if (hamburger) { hamburger.setAttribute('aria-expanded', 'false'); hamburger.focus(); }
        resetMobile();
      }

      if (hamburger)   hamburger.addEventListener('click', openDrawer);
      if (dCloseBtn)   dCloseBtn.addEventListener('click', closeDrawer);
      if (dMobileClose) dMobileClose.addEventListener('click', closeDrawer);
      if (dOverlay)    dOverlay.addEventListener('click', closeDrawer);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
      });

      // Desktop hover
      var navLinks    = drawer.querySelectorAll('.menu-drawer__nav-link');
      var subPanels   = drawer.querySelectorAll('.menu-drawer__sub-panel');
      var imagePanels = drawer.querySelectorAll('.menu-drawer__image-panel');

      navLinks.forEach(function (link) {
        link.addEventListener('mouseenter', function () {
          var id = this.dataset.blockId;
          navLinks.forEach(function (l) { l.classList.remove('is-active'); });
          subPanels.forEach(function (p) { p.classList.remove('is-active'); });
          imagePanels.forEach(function (p) { p.classList.remove('is-active'); });
          this.classList.add('is-active');
          var sp = drawer.querySelector('.menu-drawer__sub-panel[data-block-id="' + id + '"]');
          var ip = drawer.querySelector('.menu-drawer__image-panel[data-block-id="' + id + '"]');
          if (sp) sp.classList.add('is-active');
          if (ip) ip.classList.add('is-active');
        });
      });

      // Mobile slide
      function resetMobile() {
        drawer.querySelectorAll('.menu-drawer__mobile-sub').forEach(function (s) {
          s.classList.remove('is-active');
          s.setAttribute('aria-hidden', 'true');
        });
        if (dMobileMain) dMobileMain.classList.remove('is-hidden');
        // Madde 18: quicknav bar artik ana ekranda da alt panelde de gorunur -
        // ikon rengi (beyaz/siyah) hangi zeminde oldugumuza gore degisiyor.
        drawer.classList.remove('is-sub-active');
      }

      drawer.querySelectorAll('.menu-drawer__mobile-item[data-mobile-target], .menu-drawer__mobile-item-sub-part[data-mobile-target]').forEach(function (item) {
        item.addEventListener('click', function () {
          var subPanel = document.getElementById('mobile-panel-' + this.dataset.mobileTarget);
          if (!subPanel) return;
          // Bir onceki acik panel varsa once kapat - iki panel ayni anda
          // .is-active olursa (ikisi de position:absolute; inset:0) ustuste biner.
          drawer.querySelectorAll('.menu-drawer__mobile-sub.is-active').forEach(function (s) {
            if (s !== subPanel) {
              s.classList.remove('is-active');
              s.setAttribute('aria-hidden', 'true');
            }
          });
          if (dMobileMain) dMobileMain.classList.add('is-hidden');
          subPanel.classList.add('is-active');
          subPanel.setAttribute('aria-hidden', 'false');
          drawer.classList.add('is-sub-active');
        });
      });

      drawer.querySelectorAll('.menu-drawer__mobile-back').forEach(function (btn) {
        btn.addEventListener('click', resetMobile);
      });
    }

    // ---- Search Overlay ----
    var searchOverlay  = document.getElementById('header-yeni-search');
    if (!searchOverlay) return;

    var searchInput    = document.getElementById('search-overlay-q');
    function focusSearchInputAtEnd(input, options) {
      if (!input || input.disabled) return;
      input.focus(options);
      requestAnimationFrame(function () {
        if (document.activeElement !== input) return;
        var end = input.value.length;
        try { input.setSelectionRange(end, end); } catch (error) {}
      });
    }
    function resizeSearchInput() {
      if (!searchInput) return;
      searchInput.style.removeProperty('width');
    }
    var sCloseBtn      = searchOverlay.querySelector('.search-overlay__close-btn');
    var sBackBtn       = searchOverlay.querySelector('.search-overlay__back-btn');
    var sBackdrop      = searchOverlay.querySelector('.search-overlay__backdrop');
    var soEmpty        = document.getElementById('so-empty');
    var soLoading      = document.getElementById('so-loading');
    var soResults      = document.getElementById('so-results');
    var soResultsGrid  = document.getElementById('so-results-grid');
    var soResultsLabel = document.getElementById('so-results-label');
    var soResultsQuery = document.getElementById('so-results-query');
    var soResultsCount = document.getElementById('so-results-count');
    var soResultsLink  = document.getElementById('so-results-link');
    var soResultsViewMore = document.getElementById('so-results-view-more');
    var soViewButtons  = searchOverlay.querySelectorAll('.search-overlay__results-bar .pcy-view-btn');
    var soNoresults    = document.getElementById('so-noresults');
    var soNoresultsQ   = document.getElementById('so-noresults-query');
    var soSuggestions  = document.getElementById('so-suggestions');
    var searchBtns     = document.querySelectorAll('.header-yeni__search-btn');
    var searchPageUrl  = window._headerYeni.searchUrl;
    var isRTL          = (document.documentElement.lang || '').toLowerCase().startsWith('ar');
    var sizeGuideLabel = window._headerYeniI18n.sizeGuide;
    var debounceTimer;

    // `card-product-yeni` renk seçenekleri collection section'ında delegated
    // event'lerle açılıyor. Search modalı ve search sayfası aynı component'i
    // kullandığı için aynı davranışı, sonradan eklenen kartları da kapsayacak
    // şekilde search yüzeylerine bir kez bağla.
    if (!window.__pcySearchColorOptionsBound) {
      window.__pcySearchColorOptionsBound = true;

      var isSearchColorElement = function (element) {
        return !!(element && element.closest('#header-yeni-search, #SearchPageEmptyState, .template-search'));
      };

      var collapseSearchColorOptions = function (colors) {
        if (!colors) return;
        var options = colors.querySelector('.rp-card__color-options');
        if (options) {
          options.style.transform = '';
          options.style.opacity = '';
          options.style.pointerEvents = '';
        }
        colors.classList.remove('is-expanded');
      };

      var collapseOtherSearchColorOptions = function (activeColors) {
        document.querySelectorAll(
          '#header-yeni-search .rp-card__colors.is-expanded, #SearchPageEmptyState .rp-card__colors.is-expanded, .template-search .rp-card__colors.is-expanded'
        ).forEach(function (colors) {
          if (colors !== activeColors) collapseSearchColorOptions(colors);
        });
      };

      var expandSearchColorOptions = function (colors) {
        if (!colors) return;
        var options = colors.querySelector('.rp-card__color-options');
        if (!options) return;
        collapseOtherSearchColorOptions(colors);
        colors.classList.add('is-expanded');
        options.style.transform = 'scaleX(1)';
        options.style.opacity = '1';
        options.style.pointerEvents = 'auto';
      };

      document.addEventListener('click', function (event) {
        var trigger = event.target.closest('.rp-card__color-trigger');
        if (!trigger || !isSearchColorElement(trigger)) {
          if (!event.target.closest('.rp-card__colors')) collapseOtherSearchColorOptions(null);
          return;
        }
        if (window.matchMedia('(min-width: 990px)').matches) return;

        var colors = trigger.closest('.rp-card__colors');
        if (!colors || !colors.querySelector('.rp-card__color-options')) return;
        event.preventDefault();
        event.stopPropagation();
        if (colors.classList.contains('is-expanded')) {
          collapseSearchColorOptions(colors);
        } else {
          expandSearchColorOptions(colors);
        }
      });

      document.addEventListener('mouseover', function (event) {
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        var trigger = event.target.closest('.rp-card__color-trigger');
        if (!trigger || !isSearchColorElement(trigger) || trigger.contains(event.relatedTarget)) return;
        expandSearchColorOptions(trigger.closest('.rp-card__colors'));
      });

      document.addEventListener('mouseout', function (event) {
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        var card = event.target.closest('.pcy-card');
        if (!card || !isSearchColorElement(card) || card.contains(event.relatedTarget)) return;
        collapseSearchColorOptions(card.querySelector('.rp-card__colors'));
      });
    }

    function applyOverlayView(view) {
      if (soResults) {
        soResults.classList.remove('search-overlay__results--view-2', 'search-overlay__results--view-4', 'search-overlay__results--view-6');
        soResults.classList.add('search-overlay__results--view-' + view);
      }
      if (soSuggestions) {
        soSuggestions.classList.remove('search-overlay__suggestions--view-2', 'search-overlay__suggestions--view-4', 'search-overlay__suggestions--view-6');
        soSuggestions.classList.add('search-overlay__suggestions--view-' + view);
      }
      if (typeof window.pcyUpdateGridImageSizes === 'function') {
        window.pcyUpdateGridImageSizes(soResultsGrid, view);
        window.pcyUpdateGridImageSizes(soSuggestions && soSuggestions.querySelector('.search-overlay__product-grid'), view);
      }
      soViewButtons.forEach(function (button) {
        button.classList.toggle('is-active', button.dataset.view === view);
      });
    }

    var savedOverlayView = null;
    try { savedOverlayView = localStorage.getItem('pcyCollectionView'); } catch (error) {}
    applyOverlayView(savedOverlayView === '2' || savedOverlayView === '6' ? savedOverlayView : '4');

    soViewButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var view = button.dataset.view;
        if (window.matchMedia('(max-width: 989px)').matches) {
          view = ({ '4': '2', '2': '6', '6': '4' })[view] || '4';
        }
        var activeSurface = soResults && !soResults.hidden ? soResults : soSuggestions;
        var grid = activeSurface ? activeSurface.querySelector('.search-overlay__product-grid') : null;
        var scrollContainer = searchOverlay.querySelector('.search-overlay__body');
        window.pcyPreserveGridAnchor(grid, function () { applyOverlayView(view); }, scrollContainer);
        try { localStorage.setItem('pcyCollectionView', view); } catch (error) {}
      });
    });

    function openSearch() {
      // Close filter drawer if open (its click stopPropagation prevents the global click-outside handler from firing)
      var facetsWrapper = document.querySelector('.facets-wrapper');
      var btnFilter = document.querySelector('.btn-filter');
      if (facetsWrapper) facetsWrapper.classList.remove('active');
      if (btnFilter) btnFilter.classList.remove('active');
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');
      _lockScrollbar();
      searchOverlay.setAttribute('aria-hidden', 'false');
      searchOverlay.classList.add('is-open');
      document.body.classList.add('search-open');
      document.documentElement.style.overflow = 'hidden';
      if (header && header.classList.contains('header-yeni--home')) header.classList.add('is-compact');
      searchBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      if (sBackBtn) sBackBtn.classList.add('is-visible');
      var currentQuery = searchInput ? searchInput.value.trim() : '';
      if (currentQuery.length >= 2) {
        if (sCloseBtn) sCloseBtn.classList.add('is-visible');
        doSearch(currentQuery);
      } else {
        showEmpty();
      }
      setTimeout(function () { resizeSearchInput(); focusSearchInputAtEnd(searchInput); }, 80);
    }

    function closeSearch() {
      _unlockScrollbar();
      if (typeof setHeaderFilterDrawerOpen === 'function') setHeaderFilterDrawerOpen(false);
      searchOverlay.setAttribute('aria-hidden', 'true');
      searchOverlay.classList.remove('is-open');
      document.body.classList.remove('search-open');
      document.documentElement.style.overflow = '';
      if (header && header.classList.contains('header-yeni--home') && window.scrollY <= 10) {
        header.classList.remove('is-compact');
      }
      searchBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (searchInput) { searchInput.value = ''; resizeSearchInput(); }
      if (sCloseBtn) sCloseBtn.classList.remove('is-visible');
      showEmpty();
    }

    window.closeHeaderYeniSearch = closeSearch;

    searchBtns.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (searchOverlay.classList.contains('is-open')) {
          event.stopImmediatePropagation();
          closeSearch();
          return;
        } else {
          openSearch();
        }
      });
    });

    function resetSearchModalFilterCount() {
      searchOverlay.querySelectorAll('.pcy-filter-btn [data-pcy-filter-active-count]').forEach(function (count) {
        count.remove();
      });
    }

    function showEmpty() {
      resetSearchModalFilterCount();
      if (soEmpty)       soEmpty.removeAttribute('hidden');
      if (soLoading)     soLoading.setAttribute('hidden', '');
      if (soResults)     soResults.setAttribute('hidden', '');
      if (soNoresults)   soNoresults.setAttribute('hidden', '');
      if (soSuggestions) soSuggestions.removeAttribute('hidden');
    }

    function showLoading() {
      if (soEmpty)       soEmpty.setAttribute('hidden', '');
      if (soLoading)     soLoading.removeAttribute('hidden');
      if (soResults)     soResults.setAttribute('hidden', '');
      if (soNoresults)   soNoresults.setAttribute('hidden', '');
      if (soSuggestions) soSuggestions.setAttribute('hidden', '');
    }

    function activateSlide(card, idx) {
      var visualDirection = isRTL ? -1 : 1;
      var slides = card.querySelectorAll('.so-slide');
      slides.forEach(function(s, i) {
        s.classList.toggle('is-active', i === idx);
        s.style.transform = 'translateX(' + ((i - idx) * 100 * visualDirection) + '%)';
      });
      card.querySelectorAll('.so-dot').forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
      var progress = card.querySelector('.so-dots');
      if (progress && slides.length) progress.style.setProperty('--so-progress', (((idx + 1) / slides.length) * 100) + '%');
    }

    function responsiveImageUrl(src, width) {
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
    }

    function responsiveImageSrcset(src) {
      return [360, 540, 720, 960, 1200, 1600].map(function(width) {
        return responsiveImageUrl(src, width) + ' ' + width + 'w';
      }).join(', ');
    }

    function buildProductCard(p) {
      var allImgs = [];
      if (p.images && p.images.length) {
        allImgs = p.images.slice(0, 5);
      } else if (p.image) {
        allImgs = [p.image];
      }
      var slidesHtml = allImgs.map(function(imgUrl, i) {
        return '<img class="so-slide' + (i === 0 ? ' is-active' : '') + '" src="' + responsiveImageUrl(imgUrl, 540) + '" srcset="' + responsiveImageSrcset(imgUrl) + '" sizes="(min-width: 990px) 25vw, 50vw" width="540" height="720" alt="' + p.title + '" loading="' + (i === 0 ? 'eager' : 'lazy') + '" draggable="false">';
      }).join('');
      var navHtml = allImgs.length > 1
        ? '<button type="button" class="so-card__nav so-card__nav--prev" aria-label="' + window._headerYeniI18n.prevImage + '" tabindex="-1"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" class="h-5 w-5" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m15 18-6-6 6-6"></path></svg></button>' +
          '<button type="button" class="so-card__nav so-card__nav--next" aria-label="' + window._headerYeniI18n.nextImage + '" tabindex="-1"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" class="h-5 w-5" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9 18 6-6-6-6"></path></svg></button>'
        : '';
      var dotsHtml = allImgs.length > 1
        ? '<div class="so-dots" aria-hidden="true" style="--so-progress:' + (100 / allImgs.length) + '%">' + allImgs.map(function(_, i) {
            return '<span class="so-dot' + (i === 0 ? ' is-active' : '') + '" data-idx="' + i + '"></span>';
          }).join('') + '</div>'
        : '';
      var price = formatMoney(p.price_min != null ? p.price_min : p.price);
      var handle = p.handle || (p.url ? p.url.split('/products/')[1] : '');
      return '<div class="so-card" data-product-id="' + p.id + '">' +
        '<div class="search-overlay__product-img">' +
          '<a href="' + p.url + '" class="so-card__img-link">' +
            '<div class="so-slides">' + slidesHtml + '</div>' +
          '</a>' +
          navHtml +
          dotsHtml +
        '</div>' +
        '<div class="so-card__info">' +
          '<a href="' + p.url + '" class="so-card__text">' +
            '<p class="search-overlay__product-title">' + p.title + '</p>' +
            '<p class="search-overlay__product-price">' + price + '</p>' +
          '</a>' +
          '<wishlist-button-collection data-product-handle="' + handle + '" show-icon="" icon="wishlist"></wishlist-button-collection>' +
        '</div>' +
      '</div>';
    }

    window.buildSearchOverlayProductCard = buildProductCard;

    function buildSuggestionCard(product) {
      var images = (product.images || []).slice(0, 4).map(function (image) {
        return typeof image === 'string' ? image : image.src;
      }).filter(Boolean);
      if (!images.length && product.featured_image) {
        images = [typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.url || product.featured_image.src];
      }
      var variants = product.variants || [];
      var available = variants.some(function (variant) { return variant.available; });
      var slides = images.map(function (src, index) {
        return '<img class="pcy-slide' + (index === 0 ? ' is-active' : '') + '" src="' + responsiveImageUrl(src, 540) + '" srcset="' + responsiveImageSrcset(src) + '" sizes="(min-width: 990px) 25vw, 50vw" width="540" height="720" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy" draggable="false">';
      }).join('');
      var nav = images.length > 1
        ? '<button type="button" class="pcy-card__nav pcy-card__nav--prev" aria-label="Previous image" tabindex="-1"><svg width="6" height="10" viewBox="0 0 6 10" fill="none" aria-hidden="true"><path d="M4.875 9.25L0.5 4.875L4.875 0.5" stroke="#61615F" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<button type="button" class="pcy-card__nav pcy-card__nav--next" aria-label="Next image" tabindex="-1"><svg width="6" height="10" viewBox="0 0 6 10" fill="none" aria-hidden="true"><path d="M0.5 0.5L4.875 4.875L0.5 9.25" stroke="#61615F" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<div class="pcy-dots" aria-hidden="true" style="--pcy-progress:' + (100 / images.length) + '%">' + images.map(function (_, index) { return '<span class="pcy-dot' + (index === 0 ? ' is-active' : '') + '" data-idx="' + index + '"></span>'; }).join('') + '</div>'
        : '';
      var quickAdd = available
        ? '<button type="button" class="rp-card__quick-add rp-card__quick-add--media" aria-label="Choose options" aria-expanded="false"><svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true"><path d="M0.5 6.5H12.5M6.5 12.5L6.5 0.5" stroke="#61615F" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
        : '';
      var variantPanel = available
        ? '<div class="rp-card__variants" hidden>' + variants.map(function (variant) {
            var option = variant.option2 || variant.option1 || variant.title || '';
            var trackedInventory = variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny' && typeof variant.inventory_quantity === 'number'
              ? variant.inventory_quantity
              : 999999;
            return '<button type="button" class="rp-card__variant-item' + (variant.available ? '' : ' rp-card__variant-item--soldout') + '" data-variant-id="' + variant.id + '" data-available="' + variant.available + '" data-stock-available="' + variant.available + '" data-product-name="' + (product.title || '').replace(/"/g, '&quot;') + '" data-product-image="' + (images[0] || '') + '" data-product-variant="' + (variant.title || '').replace(/"/g, '&quot;') + '" data-inventory="' + trackedInventory + '">' + option + '</button>';
          }).join('') + '<modal-opener data-modal="#SizeGuideModal"><button type="button" class="rp-card__size-guide">' + sizeGuideLabel + '</button></modal-opener></div>'
        : '';

      // Renk swatch'ları
      var colorOptionsHtml = '';
      var colorGroup = (product.metafields && product.metafields.custom && product.metafields.custom.color_option && product.metafields.custom.color_option.value) || [];
      var swatchHex = (product.metafields && product.metafields.product && product.metafields.product.fe_ColorHexCode) || '';
      var colorName = (product.metafields && product.metafields.product && product.metafields.product.fe_AnaRenkKoduAciklamasi) || '';
      var extraColors = colorGroup.length > 1 ? colorGroup.length - 1 : 0;

      if (swatchHex || extraColors > 0) {
        var optionsListHtml = '';
        if (extraColors > 0) {
          optionsListHtml = '<div class="rp-card__color-options">' + colorGroup.filter(function (rel) {
            return rel && rel.id !== product.id;
          }).map(function (rel) {
            var relHex = (rel.metafields && rel.metafields.product && rel.metafields.product.fe_ColorHexCode) || '#ccc';
            var relUrl = rel.url || ((window._localeRoot || '') + '/products/' + rel.handle);
            return '<a href="' + relUrl + '" class="rp-card__color-option" style="background-color: ' + relHex + ';" tabindex="-1" title="' + (rel.title || '').replace(/"/g, '&quot;') + '"><span aria-hidden="true"></span></a>';
          }).join('') + '</div>';
        }
        colorOptionsHtml = '<div class="rp-card__colors" aria-hidden="true">' +
          '<div class="rp-card__color-trigger">' +
            (swatchHex ? '<span class="rp-card__color-swatch" style="background-color: ' + swatchHex + ';"></span>' : '') +
            (extraColors > 0 ? '<span class="rp-card__color-count">+' + extraColors + '</span>' : '') +
            (colorName ? '<span class="rp-card__color-name">' + colorName + '</span>' : '') +
          '</div>' +
          optionsListHtml +
        '</div>';
      }

      var badge2 = (product.metafields && product.metafields.custom && product.metafields.custom.badge2 && product.metafields.custom.badge2.value) || '';

      var price = variants.length
        ? variants.reduce(function (min, variant) { return Math.min(min, parseFloat(variant.price)); }, Infinity)
        : parseFloat(product.price_min != null ? product.price_min : product.price);
      var compareAtPrice = parseFloat(product.compare_at_price_min != null ? product.compare_at_price_min : (product.compare_at_price || 0));
      var onSale = Number.isFinite(compareAtPrice) && compareAtPrice > price && available;
      var discountPct = onSale ? Math.ceil(((compareAtPrice - price) * 100) / compareAtPrice) : 0;

      var priceHtml = '';
      if (onSale) {
        priceHtml = '<s class="rp-card__price-compare">' + formatMoney(compareAtPrice) + '</s>' +
          '<span class="rp-card__price-current-group">' +
            '<span class="rp-card__price-current">' + formatMoney(price) + '</span>' +
            '<span class="rp-card__price-badge">%' + discountPct + '</span>' +
          '</span>';
      } else {
        priceHtml = '<span class="rp-card__price-regular">' + formatMoney(Number.isFinite(price) ? price : 0) + '</span>';
      }

      var infoQuickAdd = quickAdd.replace('rp-card__quick-add--media', 'rp-card__quick-add--info');
      return '<li class="pcy-grid__item"><div class="pcy-card rp-card" data-product-id="' + product.id + '" data-product-handle="' + product.handle + '" data-badge2="' + badge2.replace(/"/g, '&quot;') + '">' +
        '<div class="pcy-card__media"><a href="' + product.url + '" class="pcy-card__img-link" aria-label="' + (product.title || '').replace(/"/g, '&quot;') + '"><div class="pcy-slides">' + slides + '</div></a>' + colorOptionsHtml + quickAdd + variantPanel + nav + '</div>' +
        '<div class="rp-card__info"><div class="rp-card__info-top' + (badge2 ? '' : ' rp-card__info-top--no-promo') + '"><p class="rp-card__promo-label">' + badge2.toUpperCase() + '<span aria-hidden="true"></span></p><wishlist-button-collection data-product-handle="' + product.handle + '" show-icon="" icon="wishlist"></wishlist-button-collection>' + infoQuickAdd + '</div>' +
        '<div class="rp-card__title-row"><a href="' + product.url + '" class="rp-card__title-link"><p class="rp-card__title">' + product.title + '</p></a></div>' +
        '<div class="rp-card__price-row">' + priceHtml + '</div></div></div></li>';
    }

    function initSuggestionInfinite(container) {
      if (!container || container.dataset.infiniteReady === 'true') return;
      var collectionUrl = container.dataset.collectionUrl;
      var grid = container.querySelector('.search-overlay__product-grid');
      var sentinel = container.querySelector('.search-overlay__suggestions-sentinel');
      var pageSize = parseInt(container.dataset.pageSize || '8', 10);
      var total = parseInt(container.dataset.totalProducts || '', 10);
      if (!collectionUrl || !grid || !sentinel) return;
      if (container.dataset.hasNextPage === 'false' || sentinel.hidden || (Number.isFinite(total) && grid.children.length >= total)) {
        sentinel.hidden = true;
        return;
      }

      container.dataset.infiniteReady = 'true';
      var page = 2;
      var loading = false;
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; }) || loading) return;
        loading = true;
        fetch(collectionUrl + '/products.json?limit=' + pageSize + '&page=' + page)
          .then(function (response) { return response.json(); })
          .then(function (payload) {
            var products = payload.products || [];
            products.forEach(function (product) {
              product.url = (window._localeRoot || '') + '/products/' + product.handle;
              product.images = (product.images || []).map(function (image) { return typeof image === 'string' ? image : image.src; });
              var prices = (product.variants || []).map(function (variant) { return parseFloat(variant.price); }).filter(Number.isFinite);
              product.price = prices.length ? Math.min.apply(Math, prices) : 0;
            });
            grid.insertAdjacentHTML('beforeend', products.map(buildSuggestionCard).join(''));
            if (typeof window.pcyUpdateGridImageSizes === 'function') window.pcyUpdateGridImageSizes(grid);
            if (typeof window.initSearchSuggestionCardSlider === 'function') window.initSearchSuggestionCardSlider(container);
            page += 1;
            if (!products.length || products.length < pageSize || (Number.isFinite(total) && grid.children.length >= total)) {
              container.dataset.hasNextPage = 'false';
              sentinel.hidden = true;
              observer.disconnect();
            }
          })
          .catch(function () { observer.disconnect(); })
          .finally(function () { loading = false; });
      }, { rootMargin: '500px 0px' });
      observer.observe(sentinel);
    }

    window.initSearchSuggestionInfinite = initSuggestionInfinite;
    initSuggestionInfinite(soSuggestions);

    function initSuggestionCardSlider(container) {
      if (!container) return;
      // Bu container'daki kartlari card-slider-init.liquid'in global
      // initSlider(document)'inden (DOMContentLoaded'da her .rp-card'a slider
      // baglar) muaf tut — yoksa masaustunde iki slider sistemi ayni suruklemeyi
      // isleyip 2'ser 2'ser atliyordu. Idempotent: infinite-scroll ile eklenen
      // kartlar da her cagirmada isaretlensin.
      container.querySelectorAll('.pcy-card').forEach(function (c) { c.dataset.sliderBound = 'true'; });
      if (container.dataset.cardSliderReady === 'true') return;
      container.dataset.cardSliderReady = 'true';
      var pointerStartX = 0;
      var pointerStartY = 0;
      var pointerCard = null;
      var pointerMoved = false;
      var pointerVertical = false; // dikey kaydirma tespit edilince swipe kilitlenir
      var blockClick = false;

      function move(card, step) {
        var slides = Array.from(card.querySelectorAll('.pcy-slide'));
        if (slides.length < 2) return;
        var current = slides.findIndex(function (slide) { return slide.classList.contains('is-active'); });
        var next = (current + step + slides.length) % slides.length;
        slides.forEach(function (slide, index) {
          slide.classList.toggle('is-active', index === next);
          slide.style.transform = 'translateX(' + ((index - next) * 100 * (isRTL ? -1 : 1)) + '%)';
        });
        card.querySelectorAll('.pcy-dot').forEach(function (dot, index) { dot.classList.toggle('is-active', index === next); });
        var progress = card.querySelector('.pcy-dots');
        if (progress) progress.style.setProperty('--pcy-progress', (((next + 1) / slides.length) * 100) + '%');
      }

      function startDrag(card, x, y) {
        pointerStartX = x;
        pointerStartY = y || 0;
        pointerCard = card;
        pointerMoved = false;
        pointerVertical = false;
      }
      function moveDrag(x, y) {
        if (!pointerCard) return;
        var dx = Math.abs(x - pointerStartX);
        var dy = Math.abs((y || 0) - pointerStartY);
        // Hareket dikey baskinsa (sayfa kaydirma) swipe'i bu jest boyunca kilitle.
        if (!pointerMoved && dy > 8 && dy > dx) pointerVertical = true;
        if (dx > 5) pointerMoved = true;
      }
      function endDrag(x, y) {
        if (!pointerCard) return;
        var card = pointerCard;
        pointerCard = null;
        var delta = x - pointerStartX;
        var deltaY = (y || 0) - pointerStartY;
        // Dikey kaydirma / dikey baskin jest: goruntu degistirme, tiklamayi da engelleme.
        if (pointerVertical || Math.abs(deltaY) > Math.abs(delta)) return;
        if (pointerMoved) blockClick = true; // yatay sürükleme sonrası linke gitmeyi engelle
        if (Math.abs(delta) < 30) return;
        move(card, (isRTL ? delta > 0 : delta < 0) ? 1 : -1);
      }

      container.addEventListener('click', function (event) {
        if (blockClick && event.target.closest('.pcy-card__img-link')) {
          blockClick = false;
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        var arrow = event.target.closest('.pcy-card__nav');
        if (!arrow) return;
        event.preventDefault();
        event.stopPropagation();
        move(arrow.closest('.pcy-card'), arrow.classList.contains('pcy-card__nav--next') ? 1 : -1);
      });

      // Masaustu: fare/kalem. pointerType 'touch' burada islenmez — dokunmatik
      // asagidaki touch* ile islenir; ikisi birden calisip cift move() cagirmasin.
      container.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch') return;
        var media = event.target.closest('.pcy-card__media');
        if (!media) return;
        startDrag(media.closest('.pcy-card'), event.clientX, event.clientY);
      });
      container.addEventListener('pointermove', function (event) {
        if (event.pointerType === 'touch') return;
        moveDrag(event.clientX, event.clientY);
      });
      container.addEventListener('pointerup', function (event) {
        if (event.pointerType === 'touch') return;
        if (pointerCard && pointerMoved) event.preventDefault();
        endDrag(event.clientX, event.clientY);
      });

      // Mobil: dokunmatik swipe (eskiden yalniz pointer* vardi ve dokunmatikte
      // pointercancel ile kesilip hic calismiyordu).
      container.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1) return;
        var media = event.target.closest('.pcy-card__media');
        if (!media) return;
        startDrag(media.closest('.pcy-card'), event.touches[0].clientX, event.touches[0].clientY);
      }, { passive: true });
      container.addEventListener('touchmove', function (event) {
        if (event.touches.length === 1) moveDrag(event.touches[0].clientX, event.touches[0].clientY);
      }, { passive: true });
      container.addEventListener('touchend', function (event) {
        endDrag(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
      }, { passive: true });

      container.addEventListener('dragstart', function (event) {
        if (event.target.closest('.pcy-card__media')) event.preventDefault();
      });
    }

    window.initSearchSuggestionCardSlider = initSuggestionCardSlider;
    initSuggestionCardSlider(soSuggestions);
    initSuggestionCardSlider(soResults);

    /* ---- Önerilen ürün kartları: collection ile aynı quick-add akışı ---- */
    var PCY_KLAVIYO_COMPANY_ID = 'SCGscu';
    var PCY_STRINGS = window._headerYeni.strings;

    var headerSizeSheet = document.getElementById('HeaderSearchMobileSizeSheet');
    var headerSizesView = headerSizeSheet ? headerSizeSheet.querySelector('.pcy-size-sheet__view--sizes') : null;
    var headerNotifyView = headerSizeSheet ? headerSizeSheet.querySelector('.pcy-size-sheet__view--notify') : null;
    var headerNotifyTitle = headerSizeSheet ? headerSizeSheet.querySelector('.pcy-size-sheet__notify-title') : null;
    var headerNotifyBody = headerSizeSheet ? headerSizeSheet.querySelector('.pcy-size-sheet__notify-body') : null;
    var headerNotifyLabel = headerSizeSheet ? headerSizeSheet.querySelector('.pcy-size-sheet__notify-label') : null;
    var headerNotifyInput = headerSizeSheet ? headerSizeSheet.querySelector('.pcy-size-sheet__notify-input') : null;
    var headerNotifyMessage = headerSizeSheet ? headerSizeSheet.querySelector('.pcy-size-sheet__notify-message') : null;
    var headerNotifySubmit = headerSizeSheet ? headerSizeSheet.querySelector('.pcy-size-sheet__notify-submit') : null;
    var pendingHeaderNotifyVariantId = null;

    function setSuggestionQuickAddState(card, isOpen) {
      var variants = card && card.querySelector('.rp-card__variants');
      if (!variants) return;
      variants.hidden = !isOpen;
      card.querySelectorAll('.rp-card__quick-add').forEach(function (button) {
        button.classList.toggle('is-active', isOpen);
        button.setAttribute('aria-expanded', String(isOpen));
      });
    }

    function closeSuggestionQuickAdds(activeCard) {
      if (!soSuggestions) return;
      soSuggestions.querySelectorAll('.rp-card').forEach(function (card) {
        if (card !== activeCard) setSuggestionQuickAddState(card, false);
      });
    }

    function addSuggestionVariantToCart(variantButton, card, onDone) {
      var inventory = parseInt(variantButton.dataset.inventory, 10);
      var available = variantButton.dataset.available === 'true' && (isNaN(inventory) || inventory > 0);
      if (!available || !variantButton.dataset.variantId) return;

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantButton.dataset.variantId, quantity: 1 })
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (data.status || data.__stockBlocked || data.__wishlistStockBlocked) return;
          setSuggestionQuickAddState(card, false);
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: Object.assign({}, data, { _source: 'product-form' })
          }));
          document.dispatchEvent(new CustomEvent('pcy:cart-added', { detail: {
            name: data.title || (card && card.querySelector('.rp-card__title') ? card.querySelector('.rp-card__title').textContent : ''),
            variant: data.variant_title && data.variant_title !== 'Default Title' ? data.variant_title : '',
            image: data.image || '',
            itemKey: data.key || '',
            comparePrice: data.original_price || data.compare_at_price || 0,
            finalPrice: data.final_price != null ? data.final_price : data.price,
            currency: data.currency || ''
          }}));
          if (onDone) onDone();
        })
        .catch(function (error) { console.error('Sepete ekleme hatasi:', error); });
    }

    function closeHeaderSizeSheet() {
      if (!headerSizeSheet) return;
      headerSizeSheet.classList.remove('is-open');
      document.body.classList.remove('pcy-size-sheet-open');
      window.setTimeout(function () {
        headerSizeSheet.hidden = true;
        if (headerSizesView) headerSizesView.hidden = false;
        if (headerNotifyView) headerNotifyView.hidden = true;
        headerSizeSheet.classList.remove('is-notify-view');
      }, 300);
    }

    function openHeaderNotifyForm(variantId) {
      if (!headerSizeSheet) return;
      pendingHeaderNotifyVariantId = variantId;

      if (headerNotifyTitle) headerNotifyTitle.textContent = PCY_STRINGS.notifyTitle;
      if (headerNotifyBody) headerNotifyBody.textContent = PCY_STRINGS.notifyBody;
      if (headerNotifyLabel) headerNotifyLabel.textContent = PCY_STRINGS.emailLabel;
      if (headerNotifySubmit) {
        headerNotifySubmit.textContent = PCY_STRINGS.submit;
        headerNotifySubmit.disabled = false;
      }
      if (headerNotifyInput) {
        headerNotifyInput.value = '';
        headerNotifyInput.placeholder = PCY_STRINGS.emailPlaceholder;
        headerNotifyInput.disabled = false;
      }
      if (headerNotifyMessage) {
        headerNotifyMessage.hidden = true;
        headerNotifyMessage.textContent = '';
        headerNotifyMessage.classList.remove('pcy-size-sheet__notify-message--error');
      }

      if (headerSizesView) headerSizesView.hidden = true;
      if (headerNotifyView) headerNotifyView.hidden = false;
      headerSizeSheet.classList.add('is-notify-view');
    }

    function submitHeaderNotifyForm() {
      if (!headerNotifyInput) return;
      var email = headerNotifyInput.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (headerNotifyMessage) {
          headerNotifyMessage.textContent = PCY_STRINGS.invalidEmail;
          headerNotifyMessage.classList.add('pcy-size-sheet__notify-message--error');
          headerNotifyMessage.hidden = false;
        }
        return;
      }

      if (headerNotifySubmit) headerNotifySubmit.disabled = true;
      if (headerNotifyInput) headerNotifyInput.disabled = true;
      if (headerNotifySubmit) headerNotifySubmit.textContent = PCY_STRINGS.submitting;
      if (headerNotifyMessage) headerNotifyMessage.hidden = true;

      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + PCY_KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          revision: '2023-08-15'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + pendingHeaderNotifyVariantId } }
            }
          }
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Klaviyo BIS request failed: ' + response.status);
          if (headerNotifyMessage) {
            headerNotifyMessage.textContent = PCY_STRINGS.success;
            headerNotifyMessage.classList.remove('pcy-size-sheet__notify-message--error');
            headerNotifyMessage.hidden = false;
          }
          if (headerNotifySubmit) headerNotifySubmit.textContent = PCY_STRINGS.submit;
          window.setTimeout(closeHeaderSizeSheet, 1800);
        })
        .catch(function () {
          if (headerNotifySubmit) {
            headerNotifySubmit.disabled = false;
            headerNotifySubmit.textContent = PCY_STRINGS.submit;
          }
          if (headerNotifyInput) headerNotifyInput.disabled = false;
          if (headerNotifyMessage) {
            headerNotifyMessage.textContent = PCY_STRINGS.error;
            headerNotifyMessage.classList.add('pcy-size-sheet__notify-message--error');
            headerNotifyMessage.hidden = false;
          }
        });
    }

    // ── Masaüstü "stokta yok → bildirim al" sağ paneli (PLP ile aynı) ─────────
    var headerDesktopNotify        = document.getElementById('HeaderSearchDesktopNotify');
    var headerDesktopNotifyOverlay = document.getElementById('HeaderSearchNotifyOverlay');
    var headerDesktopNotifyInput   = document.getElementById('HeaderSearchDesktopNotifyEmail');
    var headerDesktopNotifySubmit  = headerDesktopNotify ? headerDesktopNotify.querySelector('.pcy-desktop-notify__submit') : null;
    var headerDesktopNotifyMsg     = headerDesktopNotify ? headerDesktopNotify.querySelector('.pcy-desktop-notify__message') : null;
    var pendingHeaderDesktopVariantId = null;

    function openHeaderDesktopNotify(variantId) {
      if (!headerDesktopNotify || !variantId) return;
      pendingHeaderDesktopVariantId = variantId;
      headerDesktopNotify.querySelector('.pcy-desktop-notify__title').textContent = PCY_STRINGS.notifyTitle;
      headerDesktopNotify.querySelector('.pcy-desktop-notify__body').textContent  = PCY_STRINGS.notifyBody;
      headerDesktopNotify.querySelector('.pcy-desktop-notify__label').textContent = PCY_STRINGS.emailLabel;
      if (headerDesktopNotifySubmit) { headerDesktopNotifySubmit.textContent = PCY_STRINGS.submit; headerDesktopNotifySubmit.disabled = false; }
      if (headerDesktopNotifyInput) { headerDesktopNotifyInput.value = ''; headerDesktopNotifyInput.disabled = false; headerDesktopNotifyInput.placeholder = PCY_STRINGS.emailPlaceholder; }
      if (headerDesktopNotifyMsg) { headerDesktopNotifyMsg.hidden = true; headerDesktopNotifyMsg.textContent = ''; headerDesktopNotifyMsg.classList.remove('pcy-desktop-notify__message--error'); }
      headerDesktopNotify.setAttribute('aria-hidden', 'false');
      headerDesktopNotify.classList.add('is-open');
      if (headerDesktopNotifyOverlay) { headerDesktopNotifyOverlay.setAttribute('aria-hidden', 'false'); headerDesktopNotifyOverlay.classList.add('is-open'); }
    }

    function closeHeaderDesktopNotify() {
      if (!headerDesktopNotify) return;
      headerDesktopNotify.classList.remove('is-open');
      headerDesktopNotify.setAttribute('aria-hidden', 'true');
      if (headerDesktopNotifyOverlay) {
        headerDesktopNotifyOverlay.classList.remove('is-open');
        headerDesktopNotifyOverlay.setAttribute('aria-hidden', 'true');
      }
      pendingHeaderDesktopVariantId = null;
    }

    function submitHeaderDesktopNotify() {
      if (!headerDesktopNotifyInput || !pendingHeaderDesktopVariantId) return;
      var email = headerDesktopNotifyInput.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (headerDesktopNotifyMsg) { headerDesktopNotifyMsg.textContent = PCY_STRINGS.invalidEmail; headerDesktopNotifyMsg.classList.add('pcy-desktop-notify__message--error'); headerDesktopNotifyMsg.hidden = false; }
        return;
      }
      if (headerDesktopNotifySubmit) { headerDesktopNotifySubmit.disabled = true; headerDesktopNotifySubmit.textContent = PCY_STRINGS.submitting; }
      headerDesktopNotifyInput.disabled = true;
      if (headerDesktopNotifyMsg) headerDesktopNotifyMsg.hidden = true;
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + PCY_KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: { accept: 'application/json', 'content-type': 'application/json', revision: '2023-08-15' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } },
            relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + pendingHeaderDesktopVariantId } } }
          }
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Klaviyo BIS request failed: ' + response.status);
          if (headerDesktopNotifyMsg) { headerDesktopNotifyMsg.textContent = PCY_STRINGS.success; headerDesktopNotifyMsg.classList.remove('pcy-desktop-notify__message--error'); headerDesktopNotifyMsg.hidden = false; }
          if (headerDesktopNotifySubmit) headerDesktopNotifySubmit.textContent = PCY_STRINGS.submit;
          window.setTimeout(closeHeaderDesktopNotify, 1800);
        })
        .catch(function () {
          if (headerDesktopNotifySubmit) { headerDesktopNotifySubmit.disabled = false; headerDesktopNotifySubmit.textContent = PCY_STRINGS.submit; }
          headerDesktopNotifyInput.disabled = false;
          if (headerDesktopNotifyMsg) { headerDesktopNotifyMsg.textContent = PCY_STRINGS.error; headerDesktopNotifyMsg.classList.add('pcy-desktop-notify__message--error'); headerDesktopNotifyMsg.hidden = false; }
        });
    }

    if (headerDesktopNotify) {
      var _hdnClose = headerDesktopNotify.querySelector('.pcy-desktop-notify__close');
      if (_hdnClose) _hdnClose.addEventListener('click', closeHeaderDesktopNotify);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && headerDesktopNotify.classList.contains('is-open')) closeHeaderDesktopNotify();
      });
    }
    if (headerDesktopNotifyOverlay) headerDesktopNotifyOverlay.addEventListener('click', closeHeaderDesktopNotify);
    if (headerDesktopNotifySubmit) headerDesktopNotifySubmit.addEventListener('click', submitHeaderDesktopNotify);

    function openHeaderSizeSheet(card) {
      if (!headerSizeSheet || !card) return;
      var title = card.querySelector('.rp-card__title');
      var price = card.querySelector('.rp-card__price-current, .rp-card__price-regular');
      var sourceWishlist = card.querySelector('wishlist-button-collection');
      var list = headerSizeSheet.querySelector('.pcy-size-sheet__list');
      headerSizeSheet.querySelector('.pcy-size-sheet__title').textContent = title ? title.textContent.trim() : '';
      headerSizeSheet.querySelector('.pcy-size-sheet__price').textContent = price ? price.textContent.trim() : '';
      var wishlist = headerSizeSheet.querySelector('.pcy-size-sheet__wishlist');
      if (wishlist) {
        wishlist.innerHTML = '';
        if (sourceWishlist) wishlist.appendChild(sourceWishlist.cloneNode(true));
      }
      if (list) list.innerHTML = '';

      function appendSizeRow(variant) {
        var inventory = parseInt(variant.inventory, 10);
        var available = variant.available === true && (isNaN(inventory) || inventory > 0);
        var row = document.createElement('li');
        row.className = 'pcy-size-sheet__row' + (available ? '' : ' pcy-size-sheet__row--soldout');
        var size = document.createElement('span');
        size.className = 'pcy-size-sheet__row-size';
        size.textContent = variant.title;
        row.appendChild(size);
        if (available) {
          row.addEventListener('click', function () {
            var sourceButton = card.querySelector('.rp-card__variant-item[data-variant-id="' + variant.id + '"]');
            if (sourceButton) {
              addSuggestionVariantToCart(sourceButton, card, closeHeaderSizeSheet);
              return;
            }
            var virtualButton = document.createElement('button');
            virtualButton.dataset.variantId = variant.id;
            virtualButton.dataset.available = 'true';
            virtualButton.dataset.inventory = variant.inventory == null ? '' : variant.inventory;
            addSuggestionVariantToCart(virtualButton, card, closeHeaderSizeSheet);
          });
        } else {
          var notifyButton = document.createElement('button');
          notifyButton.type = 'button';
          notifyButton.className = 'pcy-size-sheet__notify';
          notifyButton.textContent = PCY_STRINGS.notifyLink;
          notifyButton.addEventListener('click', function (event) {
            event.stopPropagation();
            openHeaderNotifyForm(variant.id);
          });
          row.appendChild(notifyButton);
        }
        if (list) list.appendChild(row);
      }

      var cardVariants = Array.from(card.querySelectorAll('.rp-card__variant-item')).map(function (variantButton) {
        return {
          id: variantButton.dataset.variantId,
          title: variantButton.textContent.trim(),
          available: variantButton.dataset.available === 'true',
          inventory: variantButton.dataset.inventory
        };
      });

      if (cardVariants.length) {
        cardVariants.forEach(appendSizeRow);
      } else if (card.dataset.productHandle) {
        var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        fetch(root + 'products/' + encodeURIComponent(card.dataset.productHandle) + '.js')
          .then(function (response) {
            if (!response.ok) throw new Error('Product request failed');
            return response.json();
          })
          .then(function (product) {
            if (list) list.innerHTML = '';
            (product.variants || []).forEach(function (variant) {
              appendSizeRow({
                id: String(variant.id),
                title: variant.option2 || variant.option1 || variant.title,
                available: variant.available === true,
                inventory: null
              });
            });
          })
          .catch(function (error) { console.error('Ürün bedenleri alınamadı:', error); });
      }

      if (headerSizesView) headerSizesView.hidden = false;
      if (headerNotifyView) headerNotifyView.hidden = true;
      headerSizeSheet.classList.remove('is-notify-view');

      headerSizeSheet.hidden = false;
      window.requestAnimationFrame(function () { headerSizeSheet.classList.add('is-open'); });
      document.body.classList.add('pcy-size-sheet-open');
    }

    if (headerSizeSheet) {
      headerSizeSheet.querySelector('.pcy-size-sheet__backdrop').addEventListener('click', closeHeaderSizeSheet);
      headerSizeSheet.querySelector('.pcy-size-sheet__handle').addEventListener('click', closeHeaderSizeSheet);
      headerSizeSheet.querySelectorAll('.pcy-size-sheet__close-btn').forEach(function (btn) {
        btn.addEventListener('click', closeHeaderSizeSheet);
      });
      if (headerNotifySubmit) headerNotifySubmit.addEventListener('click', submitHeaderNotifyForm);
    }

    [soResults, soSuggestions].forEach(function (productContainer) {
      if (!productContainer) return;
      productContainer.addEventListener('click', function (event) {
        var quickAdd = event.target.closest('.rp-card__quick-add');
        if (quickAdd) {
          event.preventDefault();
          event.stopImmediatePropagation();
          var card = quickAdd.closest('.rp-card');
          if (window.matchMedia('(max-width: 989px)').matches) {
            openHeaderSizeSheet(card);
          } else {
            var variants = card && card.querySelector('.rp-card__variants');
            if (!variants) return;
            var shouldOpen = variants.hidden;
            closeSuggestionQuickAdds(card);
            setSuggestionQuickAddState(card, shouldOpen);
          }
          return;
        }

        var variantButton = event.target.closest('.rp-card__variant-item');
        if (!variantButton) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        // Stokta yoksa: mobilde size-sheet notify akışı, masaüstünde (PLP'deki gibi)
        // sağ bildirim paneli. Stoktaysa doğrudan sepete ekle.
        var _hInv = parseInt(variantButton.dataset.inventory, 10);
        var _hAvail = variantButton.dataset.available === 'true' && (isNaN(_hInv) || _hInv > 0);
        if (!_hAvail) {
          if (!variantButton.dataset.variantId) return;
          if (window.matchMedia('(max-width: 989px)').matches) {
            openHeaderSizeSheet(variantButton.closest('.rp-card'));
            openHeaderNotifyForm(variantButton.dataset.variantId);
          } else {
            openHeaderDesktopNotify(variantButton.dataset.variantId);
          }
          return;
        }
        addSuggestionVariantToCart(variantButton, variantButton.closest('.rp-card'));
      }, true);
    });

    function formatMoney(amount) {
      if (amount == null) return '';
      var num = parseFloat(amount);
      if (isNaN(num)) return '';
      var fmt = window._moneyFormat || '{{amount}}';
      return fmt
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(num).toLocaleString())
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, num.toFixed(2).replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(num).toString())
        .replace(/\{\{\s*amount\s*\}\}/g, num.toFixed(2));
    }

    function showResults(renderedCards, query, totalCount) {
      resetSearchModalFilterCount();
      if (soEmpty)       soEmpty.setAttribute('hidden', '');
      if (soLoading)     soLoading.setAttribute('hidden', '');
      if (soNoresults)   soNoresults.setAttribute('hidden', '');
      if (soSuggestions) soSuggestions.setAttribute('hidden', '');
      if (soResults)     soResults.removeAttribute('hidden');

      var count = totalCount == null ? renderedCards.length : totalCount;
      if (soResultsQuery) soResultsQuery.textContent = query || '';
      if (soResultsCount) soResultsCount.textContent = count;
      var fullResultsUrl = (window._localeRoot || '') + '/search?q=' + encodeURIComponent(query) + '&type=product';
      if (soResultsLink) soResultsLink.href = fullResultsUrl;
      if (soResultsViewMore) soResultsViewMore.href = fullResultsUrl;

      if (soResultsGrid) {
        soResultsGrid.innerHTML = renderedCards.join('');
        if (typeof window.pcyUpdateGridImageSizes === 'function') window.pcyUpdateGridImageSizes(soResultsGrid);
        if (typeof window.initSearchSuggestionCardSlider === 'function') {
          window.initSearchSuggestionCardSlider(soResults);
        }
      }
      // Sonuçlar gösterilirken drawer içeriğini hazırla; filtre tıklaması fetch'i beklemesin.
      ensureHeaderFilterDrawer(fullResultsUrl);
    }

    function showNoResults(query) {
      resetSearchModalFilterCount();
      if (soEmpty)       soEmpty.setAttribute('hidden', '');
      if (soLoading)     soLoading.setAttribute('hidden', '');
      if (soResults)     soResults.setAttribute('hidden', '');
      if (soNoresults)   soNoresults.removeAttribute('hidden');
      if (soSuggestions) soSuggestions.removeAttribute('hidden');
      if (soNoresultsQ)     soNoresultsQ.textContent = query || '';
    }

    function hydrateSearchProduct(product) {
      if (product.variants && product.variants.length) return Promise.resolve(product);
      var handle = product.handle || (product.url && product.url.split('/products/')[1]);
      if (!handle) return Promise.resolve(product);
      handle = handle.split('?')[0].split('#')[0];
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

      return fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (response) {
          if (!response.ok) throw new Error('Product request failed');
          return response.json();
        })
        .then(function (fullProduct) {
          product.handle = fullProduct.handle || handle;
          product.available = fullProduct.available;
          product.images = fullProduct.images || product.images;
          product.variants = (fullProduct.variants || []).map(function (variant) {
            return Object.assign({}, variant, { price: Number(variant.price || 0) / 100 });
          });
          return product;
        })
        .catch(function () { return product; });
    }

    function doSearch(query) {
      if (!query || query.length < 2) { showEmpty(); return; }

      showLoading();

      var pendingResultsUrl = (window._localeRoot || '') + '/search?q=' + encodeURIComponent(query) + '&type=product';
      // Search sayfası kartları `card-product-yeni` ile render ediyor. Modal da aynı
      // HTML'i kullanarak variant/renk/fiyat davranışını tek component'ten alır.
      ensureHeaderFilterDrawer(pendingResultsUrl);

      fetchSearchPageHtml(pendingResultsUrl)
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = doc.getElementById('product-grid');
          var renderedCards = grid
            ? Array.from(grid.querySelectorAll('.pcy-grid > .pcy-grid__item')).slice(0, 8).map(function (item) {
                // Search page wrapper'ındaki `grid__item` ve scroll animation
                // kuralları modal kolon ölçülerini eziyor. Kart component'ini
                // koruyup modalın kullandığı sade wrapper'a dönüştür.
                var modalItem = item.cloneNode(true);
                modalItem.className = 'pcy-grid__item';
                modalItem.removeAttribute('style');
                modalItem.removeAttribute('data-cascade');
                return modalItem.outerHTML;
              })
            : [];
          var countSource = doc.querySelector('[data-search-page-count]');
          var totalCount = countSource ? parseInt(countSource.textContent.trim(), 10) : renderedCards.length;

          if (renderedCards.length) {
            showResults(renderedCards, query, Number.isNaN(totalCount) ? renderedCards.length : totalCount);
          } else {
            showNoResults(query);
          }
        })
        .catch(function () { showEmpty(); });
    }

    if (header) {
      header.addEventListener('click', function () {
        if (searchOverlay.classList.contains('is-open')) closeSearch();
      });
    }

    if (sCloseBtn) sCloseBtn.addEventListener('click', function () {
      clearTimeout(debounceTimer);
      if (searchInput) searchInput.value = '';
      resizeSearchInput();
      sCloseBtn.classList.remove('is-visible');
      showEmpty();
      if (searchInput) searchInput.focus();
    });
    if (sBackBtn)  sBackBtn.addEventListener('click', function () {
      if (searchInput && searchInput.value.trim()) {
        searchInput.value = '';
        resizeSearchInput();
        showEmpty();
        searchInput.focus();
      } else {
        closeSearch();
      }
    });
    if (sBackdrop) sBackdrop.addEventListener('click', closeSearch);

    // Modal ve search sayfası aynı header yapısını kullanır. Input'un çevresindeki
    // boş alan veya alt border tıklandığında ilgili arama alanını odakla.
    document.addEventListener('click', function (event) {
      var focusSurface = event.target.closest('.search-overlay__header, .search-overlay__divider');
      if (!focusSurface || event.target.closest('button, a, input, select, textarea, label')) return;

      var searchHeader = focusSurface.classList.contains('search-overlay__header')
        ? focusSurface
        : focusSurface.previousElementSibling;
      var input = searchHeader && searchHeader.querySelector('input[type="search"]');
      focusSearchInputAtEnd(input, { preventScroll: true });
    });

    var headerFilterDrawer = null;
    var headerFilterOverlay = null;
    var headerFilterPromise = null;
    var headerFilterPromiseUrl = '';
    var headerFilterOpenRequest = 0;
    var headerFilterOpening = false;
    var searchPageHtmlPromises = new Map();

    function getIsolatedSearchFilterUrl(targetUrl) {
      var url = new URL(targetUrl || '/collections/all', window.location.origin);
      Array.from(url.searchParams.keys()).forEach(function (key) {
        if (key.indexOf('filter.') === 0 || key === 'sort_by' || key === 'page' || key === 'section_id') {
          url.searchParams.delete(key);
        }
      });
      return url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '');
    }

    function namespaceHeaderFilterControlIds(drawer) {
      drawer.querySelectorAll('input[id], select[id], textarea[id]').forEach(function (control, index) {
        var oldId = control.id;
        var newId = 'HeaderSearchFilter-' + index + '-' + oldId;
        drawer.querySelectorAll('label[for]').forEach(function (label) {
          if (label.getAttribute('for') === oldId) label.setAttribute('for', newId);
        });
        control.id = newId;
      });
    }

    function fetchSearchPageHtml(url) {
      if (searchPageHtmlPromises.has(url)) return searchPageHtmlPromises.get(url);

      var request = fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Search page request failed: ' + response.status);
          return response.text();
        })
        .catch(function (error) {
          searchPageHtmlPromises.delete(url);
          throw error;
        });

      searchPageHtmlPromises.set(url, request);
      return request;
    }

    function setHeaderFilterButtonsBusy(busy) {
      searchOverlay.querySelectorAll('.pcy-filter-btn, .btn-filter').forEach(function (button) {
        button.setAttribute('aria-busy', String(busy));
        button.style.pointerEvents = busy ? 'none' : '';
      });
    }

    function closeCompetingHeaderFilterDrawers(activeDrawer) {
      document.querySelectorAll('#main-search-filters, #main-suggestion-filters, #header-search-filters').forEach(function (drawer) {
        if (drawer !== activeDrawer) {
          drawer.classList.remove('active');
          drawer.style.setProperty('display', 'none', 'important');
          drawer.style.setProperty('pointer-events', 'none', 'important');
          drawer.setAttribute('aria-hidden', 'true');
          if ('inert' in drawer) drawer.inert = true;
        }
      });
      document.querySelectorAll('.template-search .pcy-filter-overlay, #suggestion-filter-overlay').forEach(function (overlay) {
        overlay.classList.remove('active');
        overlay.setAttribute('aria-hidden', 'true');
      });
    }

    function setHeaderFilterDrawerOpen(open) {
      if (open) closeCompetingHeaderFilterDrawers(headerFilterDrawer);
      if (headerFilterDrawer) {
        var closedTransform = document.documentElement.dir === 'rtl' || document.documentElement.lang.toLowerCase().indexOf('ar') === 0
          ? 'translateX(-100%)'
          : 'translateX(100%)';
        headerFilterDrawer.classList.toggle('active', open);
        headerFilterDrawer.style.setProperty('display', 'flex', 'important');
        // Collection facet CSS'indeki `.facets-wrapper:not(.active)` transform'u
        // dinamik header drawer'ının kapalı konumunu eziyor. Inline important ile
        // bu drawer'ın gerçek açık/kapalı konumunu tek kaynaktan yönet.
        headerFilterDrawer.style.setProperty('transform', open ? 'translateX(0)' : closedTransform, 'important');
        headerFilterDrawer.style.setProperty('pointer-events', open ? 'auto' : 'none', 'important');
        headerFilterDrawer.setAttribute('aria-hidden', String(!open));
        if ('inert' in headerFilterDrawer) headerFilterDrawer.inert = !open;
      }
      if (headerFilterOverlay) headerFilterOverlay.classList.toggle('active', open);
      document.documentElement.classList.toggle('overflow-hidden', open);
      document.body.classList.toggle('overflow-hidden', open);
    }
    window.closeHeaderSearchFilterDrawer = function () {
      setHeaderFilterDrawerOpen(false);
    };

    function updateHeaderDrawerBadges(drawer) {
      if (!drawer) return;
      drawer.querySelectorAll('.js-filter').forEach(function (filter) {
        var selected = filter.querySelector('.facets__summary .facets__selected');
        if (selected) {
          var count = filter.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').length;
          selected.textContent = '(' + count + ')';
          selected.classList.toggle('hidden', count === 0);
        }
      });

      var totalActive = drawer.querySelectorAll(
        '#FacetFiltersForm .js-filter input[type="checkbox"]:checked, #FacetFiltersForm .js-filter input[type="radio"]:checked'
      ).length;
      var badge = drawer.querySelector('#PcyFilterActiveCount');
      if (badge) {
        badge.textContent = '(' + totalActive + ')';
        badge.hidden = totalActive === 0;
      }
      var clearBtn = drawer.querySelector('.pcy-filters-drawer__clear');
      if (clearBtn) {
        clearBtn.style.display = totalActive > 0 ? 'block' : 'none';
      }
    }

    function getHeaderDrawerFilterParams(drawer) {
      if (!drawer) return '';
      var params = new URLSearchParams();
      // Stok filtresini yalnizca kullanici filtreleme akisini tetiklediginde ekle.
      params.set('filter.v.availability', '1');
      var added = new Set();
      drawer.querySelectorAll(
        '#FacetFiltersForm input[name], #FacetFiltersForm select[name], .pcy-sort-details input[name], .pcy-sort-details select[name]'
      ).forEach(function (control) {
        if (control.name.indexOf('filter.') !== 0 && control.name !== 'sort_by') return;
        if (control.name.indexOf('.price.') !== -1) return;
        if (control.disabled || !control.value || ((control.type === 'checkbox' || control.type === 'radio') && !control.checked)) return;
        var token = control.name + '\u0000' + control.value;
        if (added.has(token)) return;
        added.add(token);
        params.append(control.name, control.value);
      });

      ['filter.v.price.gte', 'filter.v.price.lte'].forEach(function (name) {
        var input = drawer.querySelector('#FacetFiltersForm input[name="' + name + '"]:not([type="hidden"])');
        if (!input || !input.value.trim()) return;
        var value = parseFloat(input.value.trim().replace(/\./g, '').replace(',', '.'));
        if (!Number.isNaN(value)) params.set(name, String(Math.round(value)));
      });

      return params.toString();
    }

    function ensureHeaderFilterDrawer(targetUrl) {
      targetUrl = getIsolatedSearchFilterUrl(targetUrl);
      headerFilterDrawer = document.getElementById('header-search-filters');
      headerFilterOverlay = document.getElementById('header-filter-overlay');

      if (headerFilterDrawer && headerFilterOverlay && headerFilterDrawer.dataset.targetUrl === targetUrl) {
        return Promise.resolve(headerFilterDrawer);
      }
      if (headerFilterPromise && headerFilterPromiseUrl === targetUrl) return headerFilterPromise;

      var fetchUrl = targetUrl || '/collections/all';
      headerFilterPromiseUrl = targetUrl;
      headerFilterPromise = fetchSearchPageHtml(fetchUrl)
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sourceDrawer = doc.getElementById('main-search-filters') || doc.getElementById('main-collection-filters') || doc.querySelector('.pcy-filters-drawer') || doc.querySelector('.facets-wrapper');
          if (!sourceDrawer) throw new Error('Filter drawer could not be found');

          if (!headerFilterDrawer) {
            headerFilterDrawer = document.createElement('aside');
            headerFilterDrawer.id = 'header-search-filters';
            headerFilterDrawer.className = 'facets-wrapper pcy-filters-drawer page-width';
            var initialClosedTransform = document.documentElement.dir === 'rtl' || document.documentElement.lang.toLowerCase().indexOf('ar') === 0
              ? 'translateX(-100%)'
              : 'translateX(100%)';
            headerFilterDrawer.style.setProperty('transform', initialClosedTransform, 'important');
            headerFilterDrawer.style.setProperty('pointer-events', 'none', 'important');
            headerFilterDrawer.setAttribute('aria-hidden', 'true');
            if ('inert' in headerFilterDrawer) headerFilterDrawer.inert = true;
            document.body.appendChild(headerFilterDrawer);
          }
          headerFilterDrawer.innerHTML = sourceDrawer.innerHTML;
          namespaceHeaderFilterControlIds(headerFilterDrawer);
          headerFilterDrawer.dataset.targetUrl = targetUrl;

          /* Kaynak sayfa fetch edildigi anda "Sort by" alt paneli (veya
             baska bir disclosure/submenu) acik durumda render edilmis
             olabilir (orn. o an sunucu tarafinda son secilen sort
             degeriyle ilgili bir state, ya da onceki bir etkilesimden
             kalma). Bu durumda klonlanan icerikte o alt panel <details open>
             veya "menu-opening" class'iyla geliyor ve ana filtre listesinin
             ustune (position:absolute ile) biniyor. JS davranislari
             (event listener'lar) clone ile birlikte TASINMADIGI icin bu
             state kendiliginden kapanmiyor — burada elle sifirliyoruz. */
          headerFilterDrawer.querySelectorAll('details[open]').forEach(function (d) {
            d.removeAttribute('open');
          });
          headerFilterDrawer.querySelectorAll('.menu-opening').forEach(function (el) {
            el.classList.remove('menu-opening');
          });

          if (!headerFilterOverlay) {
            headerFilterOverlay = document.createElement('div');
            headerFilterOverlay.id = 'header-filter-overlay';
            headerFilterOverlay.className = 'pcy-filter-overlay fixed inset-0 bg-black/20';
            headerFilterOverlay.style.zIndex = '515';
            headerFilterDrawer.style.zIndex = '520';
            document.body.appendChild(headerFilterOverlay);

            headerFilterOverlay.addEventListener('click', function () {
              setHeaderFilterDrawerOpen(false);
            });
          }

          headerFilterDrawer.onclick = function (e) {
            if (e.target.closest('.pcy-filters-drawer__close')) {
              e.preventDefault();
              e.stopPropagation();
              setHeaderFilterDrawerOpen(false);
              return;
            }

            if (e.target.closest('.pcy-filters-drawer__clear')) {
              e.preventDefault();
              e.stopPropagation();
              headerFilterDrawer.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(function (inp) {
                if (inp.type === 'radio') inp.checked = inp.value === 'best-selling' || inp.value === 'manual';
                else inp.checked = false;
              });
              headerFilterDrawer.querySelectorAll('input[type="number"], input[type="text"]').forEach(function (inp) {
                if (inp.name && inp.name.indexOf('filter.v.price') !== -1) inp.value = '';
              });
              headerFilterDrawer.querySelectorAll('.facet-radio li').forEach(function (li) {
                var radio = li.querySelector('input[type="radio"]');
                li.classList.toggle('active', !!(radio && radio.checked));
              });
              updateHeaderDrawerBadges(headerFilterDrawer);
              return;
            }

            var applyBtn = e.target.closest('.btn-filter-apply');
            if (applyBtn) {
              e.preventDefault();
              e.stopPropagation();
              var filterParams = getHeaderDrawerFilterParams(headerFilterDrawer);
              var baseUrl = headerFilterDrawer.dataset.targetUrl || targetUrl || '/collections/all';
              var finalUrl = baseUrl + (baseUrl.indexOf('?') > -1 ? '&' : '?') + filterParams;
              setHeaderFilterDrawerOpen(false);
              closeSearch();
              document.body.classList.add('loading');
              window.location.assign(finalUrl);
              return;
            }
          };

          headerFilterDrawer.onchange = function (e) {
            if (e.target.name === 'sort_by') {
              var list = e.target.closest('.facet-radio');
              if (list) {
                list.querySelectorAll('li').forEach(function (item) {
                  item.classList.toggle('active', item.contains(e.target));
                });
              }
            }
            updateHeaderDrawerBadges(headerFilterDrawer);
          };

          return headerFilterDrawer;
        })
        .catch(function (err) {
          console.error('[Header Search Filter Error]', err);
          return null;
        })
        .finally(function () {
          headerFilterPromise = null;
          headerFilterPromiseUrl = '';
        });

      return headerFilterPromise;
    }

    function openHeaderSearchFilterDrawer(targetUrl) {
      if (headerFilterOpening) return;
      headerFilterOpening = true;
      setHeaderFilterButtonsBusy(true);
      var requestId = ++headerFilterOpenRequest;
      ensureHeaderFilterDrawer(targetUrl).then(function (drawer) {
        if (!drawer || requestId !== headerFilterOpenRequest) return;
        setHeaderFilterDrawerOpen(true);
      }).finally(function () {
        if (requestId === headerFilterOpenRequest) {
          headerFilterOpening = false;
          setHeaderFilterButtonsBusy(false);
        }
      });
    }

    // Search modal içindeki filtre butonlarına tıklandığında filtre drawer'ını aç
    searchOverlay.addEventListener('click', function (event) {
      var filterButton = event.target.closest('.search-overlay__results .pcy-filter-btn, .search-overlay__suggestions .pcy-filter-btn, .search-overlay .btn-filter');
      if (!filterButton) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (headerFilterOpening) return;

      var q = searchInput ? searchInput.value.trim() : '';
      var isSuggestionsState = !!(soSuggestions && !soSuggestions.hidden);
      var targetUrl = '';
      if (q.length >= 2 && !isSuggestionsState) {
        targetUrl = searchPageUrl + '?q=' + encodeURIComponent(q) + '&type=product';
      } else {
        var suggestions = filterButton.closest('.search-overlay__suggestions') || soSuggestions;
        targetUrl = (suggestions && (suggestions.dataset.filterCollectionUrl || suggestions.dataset.collectionUrl)) || '/collections/all';
      }

      if (typeof window.openSearchSuggestionsDrawer === 'function' && isSuggestionsState) {
        window.openSearchSuggestionsDrawer(targetUrl);
      } else {
        openHeaderSearchFilterDrawer(targetUrl);
      }
    });

    // Arama yapılmamış modalın filtresi collection facet HTML'ini kullanıyor.
    // İlk tıklamada tam collection sayfasını bekletmemek için tarayıcı boşta
    // kaldığında aynı cache/promise üzerinden önceden hazırla.
    if (!document.getElementById('main-search-filters')) {
      var initialSuggestionFilterUrl = (soSuggestions && (soSuggestions.dataset.filterCollectionUrl || soSuggestions.dataset.collectionUrl)) || '/collections/all';
      var prefetchEmptySearchFilter = function () {
        ensureHeaderFilterDrawer(initialSuggestionFilterUrl);
      };
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(prefetchEmptySearchFilter, { timeout: 1200 });
      } else {
        window.setTimeout(prefetchEmptySearchFilter, 250);
      }
    }

    // Simetrik: filtre butonu tıklanınca arama açıksa kapat.
    // DOMContentLoaded gerekli — .btn-filter bu section'dan sonra parse edilir.
    document.addEventListener('DOMContentLoaded', function () {
      var filterOpenBtn = document.querySelector('.list-actions.pcy-toolbar .btn-filter');
      if (filterOpenBtn) {
        filterOpenBtn.addEventListener('click', function () {
          if (searchOverlay.classList.contains('is-open')) closeSearch();
        });
      }
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        resizeSearchInput();
        var q = this.value.trim();
        if (sCloseBtn) { q ? sCloseBtn.classList.add('is-visible') : sCloseBtn.classList.remove('is-visible'); }
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () { doSearch(q); }, 600);
      });

    }

    // Menü drawer içindeki arama tetikleyicileri de arama sayfasına gitsin.
    document.querySelectorAll('.menu-drawer__mobile-search-trigger').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.assign(searchPageUrl);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchOverlay.classList.contains('is-open')) closeSearch();
    });

    /* ---- Ürün kartı: dot + swipe (event delegation) ---- */
    var soSuggestionsEl = document.getElementById('so-suggestions');

    var soBlockClick = false; // sürükleme/swipe sonrası ürün linkine gitmeyi engelle

    [soResultsGrid, soSuggestionsEl].forEach(function(container) {
      if (!container) return;
      container.addEventListener('click', function(e) {
        if (soBlockClick && e.target.closest('.so-card__img-link')) {
          e.preventDefault();
          e.stopPropagation();
          soBlockClick = false;
          return;
        }
        soBlockClick = false;
        var navBtn = e.target.closest('.so-card__nav');
        if (navBtn) {
          e.preventDefault();
          e.stopPropagation();
          var card = navBtn.closest('.so-card');
          if (card) {
            var slides = card.querySelectorAll('.so-slide');
            var cur = Array.prototype.indexOf.call(slides, card.querySelector('.so-slide.is-active'));
            if (navBtn.classList.contains('so-card__nav--prev')) {
              activateSlide(card, isRTL ? (cur + 1) % slides.length : (cur - 1 + slides.length) % slides.length);
            } else {
              activateSlide(card, isRTL ? (cur - 1 + slides.length) % slides.length : (cur + 1) % slides.length);
            }
          }
          return;
        }
        var dot = e.target.closest('.so-dot');
        if (dot) {
          e.preventDefault();
          var card = dot.closest('.so-card');
          if (card) activateSlide(card, parseInt(dot.dataset.idx, 10) || 0);
        }
      });

      var touchStartX = 0;
      container.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      container.addEventListener('touchend', function(e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) < 30) return;
        var imgWrap = e.target.closest('.search-overlay__product-img');
        if (!imgWrap) return;
        var card = imgWrap.closest('.so-card');
        if (!card) return;
        var slides = card.querySelectorAll('.so-slide');
        if (slides.length < 2) return;
        soBlockClick = true;
        var active = card.querySelector('.so-slide.is-active');
        var cur = Array.prototype.indexOf.call(slides, active);
        var directionX = isRTL ? -dx : dx;
        var next = directionX < 0 ? (cur + 1) % slides.length : (cur - 1 + slides.length) % slides.length;
        activateSlide(card, next);
      }, { passive: true });
    });

    /* ---- Masaüstü mouse swipe ---- */
    var mouseStartX = 0;
    var mouseTargetCard = null;
    var mouseMoved = false;

    [soResultsGrid, soSuggestionsEl].forEach(function(container) {
      if (!container) return;
      container.addEventListener('mousedown', function(e) {
        var imgWrap = e.target.closest('.search-overlay__product-img');
        if (!imgWrap) return;
        var card = imgWrap.closest('.so-card');
        if (!card || card.querySelectorAll('.so-slide').length < 2) return;
        mouseStartX = e.clientX;
        mouseTargetCard = card;
        mouseMoved = false;
      });
      container.addEventListener('dragstart', function(e) {
        if (e.target.closest('.search-overlay__product-img')) e.preventDefault();
      });
    });

    document.addEventListener('mousemove', function(e) {
      if (!mouseTargetCard) return;
      if (Math.abs(e.clientX - mouseStartX) > 5) mouseMoved = true;
    });

    document.addEventListener('mouseup', function(e) {
      if (!mouseTargetCard) return;
      var dx = e.clientX - mouseStartX;
      var card = mouseTargetCard;
      mouseTargetCard = null;
      if (!mouseMoved) return;
      soBlockClick = true; // sürükleme sonrası linke gitmeyi engelle
      if (Math.abs(dx) < 30) return;
      var slides = card.querySelectorAll('.so-slide');
      var active = card.querySelector('.so-slide.is-active');
      var cur = Array.prototype.indexOf.call(slides, active);
      var directionX = isRTL ? -dx : dx;
      var next = directionX < 0 ? (cur + 1) % slides.length : (cur - 1 + slides.length) % slides.length;
      activateSlide(card, next);
    });

    document.querySelectorAll('.search-overlay__trend-item[data-query]').forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        var q = this.dataset.query;
        if (searchInput) {
          searchInput.value = q;
          resizeSearchInput();
        }
        if (sBackBtn)  sBackBtn.classList.add('is-visible');
        if (sCloseBtn) sCloseBtn.classList.add('is-visible');
        doSearch(q);
      });
    });
  })();

  /* ---- Mini Cart (masaüstü) ---- */
  (function() {
    var cartBtn   = document.querySelector('.header-yeni__cart-btn');
    var overlay   = document.getElementById('mini-cart-overlay');
    var panel     = document.getElementById('mini-cart');
    var closeBtn  = document.getElementById('mini-cart-close');
    var bodyEl    = document.getElementById('mini-cart-body');
    var footerEl  = document.getElementById('mini-cart-footer');
    var subtotalEl = document.getElementById('mini-cart-subtotal');
    var continueBtn = document.getElementById('mini-cart-continue');
    var cartLoadVersion = 0;
    var miniCartOpenVersion = 0;
    var pendingRemovalKeys = new Set();
    var variantComparePriceCache = {};
    /* handle -> badge2 metin (guncel dilde). Sepete eklerken satira yazilan
       properties._badge2 o anki dilde donduruluyor ve dil degisince (bu da
       tam sayfa navigasyonu oldugundan cache zaten sifirlanir) sepette eski
       dilde kalir; bu yuzden mini sepette daima urunun GUNCEL metafield
       degeri kullanilir, satir property'si sadece fetch basarisiz olursa
       yedek olarak kalir. */
    var badge2Cache = {};
    var lastRenderedCart = null;
    var preferredCartKeys = [];

    var isItemAddedMode = false;

    if (!cartBtn || !panel) return;

    function isDesktop() { return window.innerWidth >= 990; }

    function updateMiniCartTitle(count) {
      var titleEl = panel.querySelector('.mini-cart__title');
      if (!titleEl) return;
      var normalizedCount = Math.max(0, Number(count) || 0);
      if (isItemAddedMode) {
        var addedText = (window._headerYeniI18n && window._headerYeniI18n.itemAdded) || '';
        titleEl.textContent = addedText;
      } else {
        var baseTitle = window._headerYeniI18n.cart;
        titleEl.textContent = baseTitle + (normalizedCount > 0 ? ' (' + normalizedCount + ')' : '');
      }
    }

    function revealMiniCart() {
      panel.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      panel.classList.add('is-open');
      overlay.classList.add('is-open');
      document.documentElement.classList.add('mini-cart-open');
      document.body.classList.add('mini-cart-open');
    }

    function concealMiniCart() {
      panel.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      panel.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.documentElement.classList.remove('mini-cart-open');
      document.body.classList.remove('mini-cart-open');
      isItemAddedMode = false;
    }

    function openMiniCart(addedItem) {
      if (!isDesktop()) {
        refreshMiniCart();
        return;
      }
      isItemAddedMode = !!(addedItem && (addedItem.key || addedItem.id || addedItem._source));
      miniCartOpenVersion += 1;
      revealMiniCart();
      updateMiniCartTitle(lastRenderedCart ? lastRenderedCart.item_count : 0);
      if (addedItem && addedItem.key) renderAddedItemImmediately(addedItem);
      refreshMiniCart();
    }

    function closeMiniCart() {
      miniCartOpenVersion += 1;
      concealMiniCart();
    }

    cartBtn.addEventListener('click', function(e) {
      if (isDesktop()) {
        e.preventDefault();
        isItemAddedMode = false;
        openMiniCart();
      }
    });

    closeBtn.addEventListener('click', closeMiniCart);
    overlay.addEventListener('click', closeMiniCart);
    continueBtn.addEventListener('click', closeMiniCart);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeMiniCart();
    });

    function updateCartCountBadge(count) {
      var normalizedCount = Math.max(0, Number(count) || 0);
      var badge = document.querySelector('.header-yeni__cart-count');
      if (badge) {
        badge.textContent = normalizedCount;
        badge.style.display = normalizedCount > 0 ? '' : 'none';
      }
      updateMiniCartTitle(normalizedCount);
      var cartTabCount = document.querySelector('.cart-nav-tab__count');
      if (cartTabCount) cartTabCount.textContent = '(' + normalizedCount + ')';
    }

    function loadCart() {
      var requestVersion = ++cartLoadVersion;
      return fetch((window._localeRoot || '') + '/cart.js', {
        headers: { 'Accept': 'application/json' },
        cache: 'no-store'
      })
        .then(function(r) {
          if (!r.ok) throw new Error('Cart request failed');
          return r.json();
        })
        .then(function(cart) {
          if (requestVersion !== cartLoadVersion) {
            var staleError = new Error('A newer cart request is already in progress');
            staleError.name = 'StaleCartRequest';
            throw staleError;
          }
          return renderCart(cart, requestVersion);
        });
    }

    function refreshMiniCart() {
      return loadCart().catch(function(error) {
        if (error && error.name !== 'StaleCartRequest') {
          console.error('Mini cart could not be refreshed:', error);
        }
      });
    }

    function applyPendingRemovalStates() {
      bodyEl.querySelectorAll('.mini-cart__item[data-key]').forEach(function(itemEl) {
        var isPending = pendingRemovalKeys.has(itemEl.dataset.key);
        itemEl.classList.toggle('is-removing', isPending);
        if (isPending) {
          itemEl.setAttribute('aria-busy', 'true');
        } else {
          itemEl.removeAttribute('aria-busy');
        }
      });
    }

    function reconcileCartOrder(cart) {
      var serverItems = Array.isArray(cart.items) ? cart.items : [];
      var itemsByKey = new Map(serverItems.map(function(item) { return [item.key, item]; }));
      var orderedItems = [];

      /* Optimistik add.js satirlarinin konumunu item.key ile koru. cart.js
         ayni satirin kesin verisini getirdiginde index degil key eslesir. */
      preferredCartKeys.forEach(function(key) {
        var item = itemsByKey.get(key);
        if (!item) return;
        orderedItems.push(item);
        itemsByKey.delete(key);
      });
      serverItems.forEach(function(item) {
        if (!itemsByKey.has(item.key)) return;
        orderedItems.push(item);
        itemsByKey.delete(item.key);
      });

      preferredCartKeys = orderedItems.map(function(item) { return item.key; });
      return Object.assign({}, cart, { items: orderedItems });
    }

    function renderCartRows(cart) {
      var cartSignature = cart.items.map(function(item) {
        return item.key + ':' + (Number(item.quantity) || 1);
      }).join('|');

      /* Siralama ve miktarlar degismediyse ayni satirlari yerinde guncelle.
         innerHTML'i tekrar kurmak urunlerin yanip sonmesine neden oluyordu. */
      if (bodyEl.dataset.cartSignature === cartSignature && bodyEl.querySelector('.mini-cart__item')) {
        cart.items.forEach(function(item) {
          bodyEl.querySelectorAll('.mini-cart__item[data-key]').forEach(function(row) {
            if (row.dataset.key !== item.key) return;
            var price = row.querySelector('.mini-cart__price-badge, .mini-cart__price-regular');
            if (price) price.textContent = formatMoneyMC(item.final_price);
          });
        });
        updateCartRowComparePrices(cart);
        if (subtotalEl) subtotalEl.textContent = formatMoneyMC(cart.total_price);
        footerEl.style.display = '';
        applyPendingRemovalStates();
        return;
      }

      var rowsHtml = [];
      cart.items.forEach(function(item) {
        var qty = item.quantity || 1;
        for (var i = 0; i < qty; i++) rowsHtml.push(buildCartItem(item, qty - 1));
      });
      bodyEl.innerHTML = rowsHtml.join('');
      bodyEl.dataset.loaded = '1';
      bodyEl.dataset.cartSignature = cartSignature;
      if (subtotalEl) subtotalEl.textContent = formatMoneyMC(cart.total_price);
      footerEl.style.display = '';
      bodyEl.querySelectorAll('.mini-cart__remove').forEach(function(btn) {
        btn.addEventListener('click', function() {
          removeItem(this.dataset.key, parseInt(this.dataset.targetQty, 10), this);
        });
      });
      applyPendingRemovalStates();
    }

    function updateCartRowComparePrices(cart) {
      (cart.items || []).forEach(function(item) {
        var hasProductCompare = item.compare_at_price && item.compare_at_price > item.original_price;
        var hasDiscountCompare = !hasProductCompare && item.original_price > item.final_price;
        var compareValue = hasProductCompare ? item.compare_at_price : (hasDiscountCompare ? item.original_price : 0);
        bodyEl.querySelectorAll('.mini-cart__item[data-key]').forEach(function(row) {
          if (row.dataset.key !== item.key) return;
          var pricing = row.querySelector('.mini-cart__item-pricing');
          if (!pricing) return;
          /* compare_at_price /cart.js'den ilk anda gelmiyor, bu fonksiyon
             onu ayrica fetch edip sonradan doldurunca cagriliyor — ilk
             cizimde (buildCartItem) secilen fiyat class'i (rozetli/duz) o
             an henuz bilinmeyen bu bilgiye gore verilmisti, burada gercek
             durum netlesince class'i da guncelliyoruz. */
          var priceEl = pricing.querySelector('.mini-cart__price-badge, .mini-cart__price-regular');
          if (priceEl) {
            priceEl.className = compareValue ? 'mini-cart__price-badge' : 'mini-cart__price-regular';
          }
          var existing = pricing.querySelector('.mini-cart__compare-price');
          if (!compareValue) {
            if (existing) existing.remove();
            return;
          }
          if (!existing) {
            existing = document.createElement('span');
            existing.className = 'mini-cart__compare-price';
            pricing.insertBefore(existing, pricing.firstChild);
          }
          existing.textContent = formatMoneyMC(compareValue);
        });
      });
    }

    function updateCartRowBadge2(cart) {
      (cart.items || []).forEach(function(item) {
        var handle = item.handle || (item.url ? item.url.split('/products/')[1].split('?')[0] : '');
        /* Fetch basarili olduysa guncel deger kullanilir; basarisiz olduysa
           (nadir) tek seferlik olarak eski properties degerine dusulur —
           satir zaten ilk cizimde bos gosterildigi icin burada ikinci bir
           dil degisimi/flas olmaz, sadece bir kerelik ortaya cikis olur. */
        var badge2 = Object.prototype.hasOwnProperty.call(badge2Cache, handle)
          ? badge2Cache[handle]
          : ((item.properties && item.properties._badge2) || '');
        bodyEl.querySelectorAll('.mini-cart__item[data-key]').forEach(function(row) {
          if (row.dataset.key !== item.key) return;
          var top = row.querySelector('.mini-cart__item-top');
          var existing = top && top.querySelector('.mini-cart__compare-label');
          if (!top || !badge2) {
            if (existing) existing.remove();
            return;
          }
          if (!existing) {
            existing = document.createElement('span');
            existing.className = 'mini-cart__compare-label';
            top.insertBefore(existing, top.firstChild);
          }
          existing.textContent = badge2.toUpperCase();
        });
      });
    }

    function syncVariantAvailabilityFromCart(cart) {
      var quantitiesByVariant = {};
      (cart.items || []).forEach(function(item) {
        var variantId = String(item.variant_id || item.id || '');
        if (!variantId) return;
        quantitiesByVariant[variantId] = (quantitiesByVariant[variantId] || 0) + (item.quantity || 0);
      });

      var variantSelector = [
        '.rp-card__variant-item[data-variant-id]',
        '.card__variant-item[data-variant-id]',
        '.variant-option[data-variant-id]',
        '.pcy-size-sheet__size-btn[data-variant-id]'
      ].join(',');

      document.querySelectorAll(variantSelector).forEach(function(button) {
        var variantId = String(button.dataset.variantId || '');
        var inventoryLimit = parseInt(button.dataset.inventory, 10);
        if (button.dataset.stockAvailable == null) {
          button.dataset.stockAvailable = String(button.dataset.available !== 'false');
        }

        /* Wishlist kartlarında stok haritası kart yüklendikten sonra gelebiliyor.
           Butonda yoksa aynı varyantın kaynak butonundan veya kart haritasından al. */
        if (isNaN(inventoryLimit)) {
          var sourceButton = Array.prototype.find.call(
            document.querySelectorAll('[data-variant-id="' + variantId + '"][data-inventory]'),
            function(candidate) { return candidate !== button; }
          );
          if (sourceButton) inventoryLimit = parseInt(sourceButton.dataset.inventory, 10);
        }
        if (isNaN(inventoryLimit)) {
          var inventoryOwner = button.closest('[data-inventory-map]');
          if (inventoryOwner) {
            try {
              inventoryLimit = parseInt(JSON.parse(inventoryOwner.dataset.inventoryMap || '{}')[variantId], 10);
            } catch (e) { /* Geçersiz wishlist cache'i diğer kartları etkilemesin. */ }
          }
        }
        var quantityInCart = quantitiesByVariant[variantId] || 0;
        var isAvailable;
        if (isNaN(inventoryLimit) || inventoryLimit >= 999999) {
          /* Kesin stok adedi bulunmayan kartlarda sepette ürün varken mevcut
             stok kontrolünün sonucunu koru; çıkarılınca başlangıç durumuna dön. */
          if (quantityInCart > 0) return;
          isAvailable = button.dataset.stockAvailable === 'true';
        } else {
          isAvailable = inventoryLimit > 0 && quantityInCart < inventoryLimit;
        }
        button.dataset.available = String(isAvailable);
        if (button.classList.contains('card__variant-item')) {
          button.classList.toggle('out-of-stock', !isAvailable);
        } else if (button.classList.contains('variant-option')) {
          button.classList.toggle('is-oos', !isAvailable);
        } else if (button.classList.contains('pcy-size-sheet__size-btn')) {
          button.classList.toggle('pcy-size-sheet__size-btn--soldout', !isAvailable);
        } else {
          button.classList.toggle('rp-card__variant-item--soldout', !isAvailable);
        }
        button.toggleAttribute('aria-disabled', !isAvailable);
      });
    }

    function renderCart(cart, requestVersion) {
      if (requestVersion && requestVersion !== cartLoadVersion) {
        var staleError = new Error('A newer cart request is already in progress');
        staleError.name = 'StaleCartRequest';
        return Promise.reject(staleError);
      }
      cart = reconcileCartOrder(cart);
      lastRenderedCart = cart;
      updateCartCountBadge(cart.item_count);
      syncVariantAvailabilityFromCart(cart);
      if (!cart.items || cart.items.length === 0) {
        bodyEl.innerHTML = '<p class="mini-cart__empty">' + ((window._headerYeniI18n || {}).cartEmpty || '') + '</p>';
        bodyEl.dataset.loaded = '1';
        delete bodyEl.dataset.cartSignature;
        footerEl.style.display = 'none';
        return Promise.resolve();
      }
      /* /cart.js compare_at_price alanını güvenilir biçimde döndürmüyor. Önce
         variant cache'ini uygula, eksikleri tamamla ve satırları yalnızca bir
         kez çiz; aksi halde compare fiyat her refresh'te kaybolup geri geliyor. */
      cart.items.forEach(function(item) {
        if (!item.compare_at_price && variantComparePriceCache[item.variant_id] > 0) {
          item.compare_at_price = variantComparePriceCache[item.variant_id];
        }
      });

      var getHandle = function(item) {
        return item.handle || (item.url ? item.url.split('/products/')[1].split('?')[0] : '');
      };
      var handles = [];
      cart.items.forEach(function(item) {
        var needsPrice = !item.compare_at_price && !Object.prototype.hasOwnProperty.call(variantComparePriceCache, item.variant_id);
        var needsBadge2 = !Object.prototype.hasOwnProperty.call(badge2Cache, getHandle(item));
        if (!needsPrice && !needsBadge2) return;
        var h = getHandle(item);
        if (h && handles.indexOf(h) === -1) handles.push(h);
      });
      if (handles.length === 0) {
        renderCartRows(cart);
        return Promise.resolve();
      }
      /* Sepet satirlarini urun detay isteklerini bekletmeden goster. Eksik
         compare fiyatlar ve guncel dildeki badge2 metni istekler
         tamamlaninca yerinde guncellenir. */
      renderCartRows(cart);
      var compareMap = {}; /* variantId -> compare_at_price */
      var fetches = handles.map(function(handle) {
        var priceFetch = fetch('/products/' + handle + '.js')
          .then(function(r) { return r.json(); })
          .then(function(p) {
            (p.variants || []).forEach(function(v) {
              variantComparePriceCache[v.id] = v.compare_at_price || 0;
              if (v.compare_at_price) {
                compareMap[v.id] = v.compare_at_price;
              }
            });
          })
          .catch(function() {});
        /* /products/{handle}.js metafield dondurmuyor; guncel dildeki badge2
           icin section rendering API'siyle kucuk bir JSON parcasi cekiliyor
           (ayni teknik custom-wishlist-page.js'te de kullaniliyor). */
        var badge2Fetch = fetch((window._localeRoot || '') + '/products/' + handle + '?section_id=wishlist-collection-info')
          .then(function(r) { if (!r.ok) throw new Error('badge2 fetch failed'); return r.text(); })
          .then(function(html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var scriptTag = doc.querySelector('#wishlist-product-collections-data');
            var data = scriptTag && scriptTag.textContent ? JSON.parse(scriptTag.textContent) : null;
            /* data.badge2 gercekten JSON'da yoksa (script bulunamadi/parse
               basarisiz) cache'i kirletme; boylece buildCartItem eski
               properties._badge2 degerine guvenli sekilde geri doner. */
            if (data && typeof data.badge2 === 'string') {
              badge2Cache[handle] = data.badge2;
            }
          })
          .catch(function() {});
        return Promise.all([priceFetch, badge2Fetch]);
      });
      return Promise.all(fetches).then(function() {
        if (requestVersion && requestVersion !== cartLoadVersion) {
          var staleError = new Error('A newer cart request is already in progress');
          staleError.name = 'StaleCartRequest';
          throw staleError;
        }
        cart.items.forEach(function(item) {
          if (!item.compare_at_price && compareMap[item.variant_id]) {
            item.compare_at_price = compareMap[item.variant_id];
          }
        });
        updateCartRowComparePrices(cart);
        updateCartRowBadge2(cart);
      });
    }

    /* cart/add.js zaten eklenen satirin tum temel verisini donduruyor. Bu
       cevabi aninda mevcut mini sepete uygula; /cart.js arkada toplamlar,
       indirimler ve miktarlar icin kesin sunucu durumuyla uzlastirir. */
    function renderAddedItemImmediately(addedItem) {
      preferredCartKeys = [addedItem.key].concat(preferredCartKeys.filter(function(key) {
        return key !== addedItem.key;
      }));

      if (!lastRenderedCart || !Array.isArray(lastRenderedCart.items)) {
        var initialQuantity = Number(addedItem.quantity) || 1;
        var initialUnitPrice = Number(addedItem.final_price);
        if (!Number.isFinite(initialUnitPrice)) initialUnitPrice = Number(addedItem.price) || 0;
        renderCart({
          items: [addedItem],
          item_count: initialQuantity,
          total_price: initialUnitPrice * initialQuantity
        }).catch(function(error) {
          console.error('Added cart item could not be rendered immediately:', error);
        });
        return;
      }
      var existingItems = lastRenderedCart && Array.isArray(lastRenderedCart.items)
        ? lastRenderedCart.items.slice()
        : [];
      var existingIndex = existingItems.findIndex(function(item) {
        return item.key === addedItem.key;
      });
      var addedQuantity = Number(addedItem.quantity) || 1;

      if (existingIndex > -1) {
        var previousItem = existingItems[existingIndex];
        /* Ayni key zaten gorunuyorsa miktari tahmin ederek iki kez arttirma.
           Satirin temel verisini add.js ile yenile; kesin miktari cart.js getirir. */
        existingItems[existingIndex] = Object.assign({}, previousItem, addedItem, {
          quantity: Number(previousItem.quantity) || addedQuantity
        });
      } else {
        existingItems.unshift(addedItem);
      }

      var previousCount = lastRenderedCart ? Number(lastRenderedCart.item_count) || 0 : 0;
      var previousTotal = lastRenderedCart ? Number(lastRenderedCart.total_price) || 0 : 0;
      var addedUnitPrice = Number(addedItem.final_price);
      if (!Number.isFinite(addedUnitPrice)) addedUnitPrice = Number(addedItem.price) || 0;
      var addedLinePrice = addedUnitPrice * addedQuantity;
      var immediateCart = Object.assign({}, lastRenderedCart || {}, {
        items: existingItems,
        item_count: previousCount + addedQuantity,
        total_price: previousTotal + addedLinePrice
      });

      renderCart(immediateCart).catch(function(error) {
        if (error && error.name !== 'StaleCartRequest') {
          console.error('Added cart item could not be rendered immediately:', error);
        }
      });
    }

    function removeItem(key, targetQty, trigger) {
      if (pendingRemovalKeys.has(key)) return;
      /* Silme basladigi anda daha once acilmis /cart.js isteklerini gecersiz
         kil. Aksi halde eski sepet cevabi silinen (kampanyayla 0 fiyatli
         olabilen) satiri yeniden cizer, change.js cevabi gelince tekrar siler. */
      var removalVersion = ++cartLoadVersion;
      pendingRemovalKeys.add(key);
      var pendingItem = trigger && trigger.closest('.mini-cart__item');
      if (pendingItem) {
        pendingItem.classList.add('is-removing');
        pendingItem.setAttribute('aria-busy', 'true');
      }
      fetch((window._localeRoot || '') + '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: isNaN(targetQty) ? 0 : targetQty })
      })
      .then(function(r) {
        if (!r.ok) throw new Error('Cart update failed');
        return r.json();
      })
      .then(function(cart) {
        pendingRemovalKeys.delete(key);
        /* Bu silmeden sonra baska bir sepet islemi basladiysa eski silme
           cevabinin da yeni durumu ezmesine izin verme. */
        if (removalVersion !== cartLoadVersion) return;
        var renderPromise = renderCart(cart, removalVersion);
        var changedItem = (cart.items || []).find(function(item) { return item.key === key; });
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            item_count: cart.item_count || 0,
            items: cart.items || [],
            changed_key: key,
            changed_quantity: changedItem ? changedItem.quantity : 0,
            _source: 'mini-cart'
          }
        }));
        return renderPromise.catch(function(error) {
          if (error && error.name === 'StaleCartRequest') return;
          throw error;
        });
      })
      .catch(function(error) {
        pendingRemovalKeys.delete(key);
        applyPendingRemovalStates();
        console.error('Cart item could not be removed:', error);
      });
    }

    function buildCartItem(item, targetQtyAfterRemove) {
      var i18n = window._headerYeniI18n || {};
      var hasProductCompare = item.compare_at_price && item.compare_at_price > item.original_price;
      var hasDiscountCompare = !hasProductCompare && item.original_price > item.final_price;
      var hasCompare = hasProductCompare || hasDiscountCompare;
      var strikethroughPrice = hasProductCompare ? item.compare_at_price : item.original_price;
      var imgSrc = item.image
        ? (item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200')
        : '';
      var itemHandle = item.handle || (item.url ? item.url.split('/products/')[1].split('?')[0] : '');
      /* Guncel dildeki deger fetch ile gelene kadar bos birakilir; eski
         properties._badge2 burada gosterilmez, aksi halde once yanlis
         dilde metin cikip sonra dogruya donerdi (bkz. updateCartRowBadge2). */
      var badge2 = Object.prototype.hasOwnProperty.call(badge2Cache, itemHandle)
        ? badge2Cache[itemHandle]
        : '';
      var compareLabel = badge2
        ? '<span class="mini-cart__compare-label">' + escapeHtmlMC(badge2).toUpperCase() + '</span>'
        : '';
      var variantText = '';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        var variantParts = item.variant_title.split(' / ');
        var sizeValue = variantParts.pop();
        var detailValue = variantParts.reverse().join(' / ');
        variantText = '<p class="mini-cart__item-variant">' +
          '<span class="mini-cart__item-size">' + escapeHtmlMC(sizeValue) + '</span>' +
          (detailValue
            ? '<span class="mini-cart__item-variant-separator" aria-hidden="true">/</span>' +
              '<span class="mini-cart__item-variant-detail">' + escapeHtmlMC(detailValue) + '</span>'
            : '') +
          '</p>';
      }
      var comparePrice = hasCompare
        ? '<span class="mini-cart__compare-price">' + formatMoneyMC(strikethroughPrice) + '</span>'
        : '';
      return '<div class="mini-cart__item" data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="mini-cart__item-img-link">' +
          '<img src="' + imgSrc + '" alt="' + (item.product_title || '') + '" class="mini-cart__item-img">' +
        '</a>' +
        '<div class="mini-cart__item-info">' +
          '<div class="mini-cart__item-top">' +
            compareLabel +
            '<p class="mini-cart__item-title">' + (item.product_title || '') + '</p>' +
            variantText +
          '</div>' +
          '<div class="mini-cart__item-bottom">' +
            '<div class="mini-cart__item-pricing">' +
              comparePrice +
              '<span class="' + (hasCompare ? 'mini-cart__price-badge' : 'mini-cart__price-regular') + '">' + formatMoneyMC(item.final_price) + '</span>' +
            '</div>' +
            '<button type="button" class="mini-cart__remove" data-key="' + item.key + '" data-target-qty="' + targetQtyAfterRemove + '" aria-label="' + (i18n.removeProduct || '') + '">' + (i18n.remove || '') + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }

    function escapeHtmlMC(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function formatMoneyMC(cents) {
      if (cents == null) return '';
      var num = parseFloat(cents) / 100;
      if (isNaN(num)) return '';
      var fmt = window._moneyFormat || '{{amount}}';
      return fmt
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(num).toLocaleString())
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, num.toFixed(2).replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(num).toString())
        .replace(/\{\{\s*amount\s*\}\}/g, num.toFixed(2));
    }

    document.addEventListener('cart:updated', function (event) {
      var detail = event && event.detail;
      if (detail && detail._source === 'mini-cart') return;
      if (detail && (detail._source === 'product-form' || detail._source === 'wishlist' || detail._source === 'wishlist-add' || detail._source === 'wishlist-page' || detail._source === 'related-products' || detail._source === 'related-products-rendered')) {
        // Masaüstü-only panel: mobilde açılırsa CSS ile gizli kaldığı için
        // kapatma yolu hiç görünmez, mini-cart-open class'ı html/body'de asılı
        // kalıp scroll'u kilitler (bkz. product-yeni.liquid "Madde 20" — aynı
        // sorun PDP'de daha önce yaşanmış, wishlist tarafı da aynı riski taşıyor).
        if (isDesktop()) {
          var activeSearchOverlay = document.getElementById('header-yeni-search');
          if (activeSearchOverlay && activeSearchOverlay.classList.contains('is-open') && typeof window.closeHeaderYeniSearch === 'function') {
            window.closeHeaderYeniSearch();
          }
          openMiniCart(detail);
        } else {
          refreshMiniCart();
        }
      } else if (detail && detail._source === 'cart-items') {
        // Cart sayfasındaki adet/silme işlemi: mini-cart paneli kapalıysa
        // pahalı yeniden render (kalem başına /products/*.js + collection-info
        // istekleri) yerine sadece header rozetini güncelle. Panel açılırken
        // zaten kendini yeniliyor (openMiniCart -> refreshMiniCart).
        var miniCartOpen = panel && panel.classList.contains('is-open');
        if (miniCartOpen) {
          refreshMiniCart();
        } else if (typeof detail.item_count === 'number') {
          updateCartCountBadge(detail.item_count);
        }
      } else {
        refreshMiniCart();
      }
    });

    window.openMiniCart = openMiniCart;
    window.closeMiniCart = closeMiniCart;
    window.refreshMiniCart = refreshMiniCart;
  })();

  /* ---- Dil değiştirici ---- */
  (function () {
    document.querySelectorAll('.header-yeni__lang').forEach(function (wrap) {
      var trigger = wrap.querySelector('.header-yeni__lang-trigger');
      var list = wrap.querySelector('.header-yeni__lang-list');
      var form = wrap.querySelector('form');
      var input = wrap.querySelector('input[name="locale_code"]');
      if (!trigger || !list) return;

      function close() {
        wrap.classList.remove('is-open');
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      }
      function open() {
        /* Account modal (z-index:200) header ile ayni katmanda ve DOM'da
           sonra geldigi icin dropdown'in ustunu kapatir; acikken once onu
           kapat ki dil listesi gorunur kalsin. */
        if (window.closeAccountModal) window.closeAccountModal();
        wrap.classList.add('is-open');
        list.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        if (wrap.classList.contains('is-open')) close(); else open();
      });

      wrap.querySelectorAll('.header-yeni__lang-link').forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          if (input) input.value = link.dataset.value;
          if (form) form.submit();
        });
      });

      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) close();
      });
    });
  })();

  /* ---- Account Modal (sadece giriş yapılmışsa) ---- */
  (function() {
    var accountBtn = document.getElementById('header-yeni-account-btn');
    if (!accountBtn) return; // giriş yapılmamış, buton yok

    var overlay = document.getElementById('account-modal-overlay');
    var modal   = document.getElementById('account-modal');

    function openModal() {
      modal.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');
      overlay.classList.add('is-open');
      document.documentElement.classList.add('account-modal-open');
      document.body.classList.add('account-modal-open');
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      modal.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.documentElement.classList.remove('account-modal-open');
      document.body.classList.remove('account-modal-open');
    }

    accountBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (modal.classList.contains('is-open')) {
        closeModal();
      } else {
        openModal();
      }
    });

    overlay.addEventListener('click', closeModal);

    var backBtn = document.getElementById('account-modal-back');
    if (backBtn) backBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    window.closeAccountModal = closeModal;
  })();
